<template>
  <div>
    <div v-if="showButtonStart == true" class="conf-start-page">
      <!-- Background shapes -->
      <div class="conf-start-bg-shape conf-start-bg-shape-1"></div>
      <div class="conf-start-bg-shape conf-start-bg-shape-2"></div>
      <div class="conf-start-bg-shape conf-start-bg-shape-3"></div>

      <div class="conf-start-content">
        <!-- Illustration -->
        <div class="conf-start-img-wrap">
          <img src="../../assets/Confirmation.svg" alt="Confirmation" class="conf-start-img" />
        </div>

        <!-- Text -->
        <h1 class="conf-start-title">Order Confirmation</h1>
        <p class="conf-start-desc">
          <span v-if="!vShow">Ready to start confirming orders? Click below to get your next order.</span>
          <span v-else>You have pending work. Click below to continue where you left off.</span>
        </p>

        <!-- Stats badges -->
        <div class="conf-start-badges">
          <div class="conf-start-badge">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
            <span>Secure</span>
          </div>
          <div class="conf-start-badge">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
            <span>Real-time</span>
          </div>
          <div class="conf-start-badge">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
            <span>Call Center</span>
          </div>
        </div>

        <!-- Button -->
        <button
          :class="loadinggetorder ? 'noselect' : ''"
          class="conf-start-btn"
          @click="startConfirmation"
          :disabled="loadinggetorder"
        >
          <loading :active.sync="loadinggetorder" :is-full-page="fullPage"></loading>
          <span class="conf-start-btn-text">
            <span v-if="!vShow">Start</span>
            <span v-else>Continue</span>
          </span>
          <svg class="conf-start-btn-arrow" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>
          </svg>
        </button>
      </div>
    </div>

    <!-- _____________________________________________________ 1 page Confirmation _____________________ -->
    <div v-if="order._id && showButtonStart == false" class="font-sans conf-main-page relative">
      <!-- Background: Dotted Africa Map -->
      <svg class="conf-africa-dots" viewBox="0 0 200 240" xmlns="http://www.w3.org/2000/svg">
        <!-- North Africa -->
        <circle cx="90" cy="10" r="2.5"/><circle cx="100" cy="10" r="2.5"/><circle cx="110" cy="10" r="2.5"/><circle cx="120" cy="10" r="2.5"/><circle cx="130" cy="10" r="2.5"/><circle cx="140" cy="10" r="2.5"/>
        <circle cx="80" cy="18" r="2.5"/><circle cx="90" cy="18" r="2.5"/><circle cx="100" cy="18" r="2.5"/><circle cx="110" cy="18" r="2.5"/><circle cx="120" cy="18" r="2.5"/><circle cx="130" cy="18" r="2.5"/><circle cx="140" cy="18" r="2.5"/><circle cx="150" cy="18" r="2.5"/>
        <circle cx="80" cy="26" r="2.5"/><circle cx="90" cy="26" r="2.5"/><circle cx="100" cy="26" r="2.5"/><circle cx="110" cy="26" r="2.5"/><circle cx="120" cy="26" r="2.5"/><circle cx="130" cy="26" r="2.5"/><circle cx="140" cy="26" r="2.5"/><circle cx="150" cy="26" r="2.5"/><circle cx="160" cy="26" r="2.5"/>
        <!-- Sahara -->
        <circle cx="70" cy="34" r="2.5"/><circle cx="80" cy="34" r="2.5"/><circle cx="90" cy="34" r="2.5"/><circle cx="100" cy="34" r="2.5"/><circle cx="110" cy="34" r="2.5"/><circle cx="120" cy="34" r="2.5"/><circle cx="130" cy="34" r="2.5"/><circle cx="140" cy="34" r="2.5"/><circle cx="150" cy="34" r="2.5"/><circle cx="160" cy="34" r="2.5"/>
        <circle cx="60" cy="42" r="2.5"/><circle cx="70" cy="42" r="2.5"/><circle cx="80" cy="42" r="2.5"/><circle cx="90" cy="42" r="2.5"/><circle cx="100" cy="42" r="2.5"/><circle cx="110" cy="42" r="2.5"/><circle cx="120" cy="42" r="2.5"/><circle cx="130" cy="42" r="2.5"/><circle cx="140" cy="42" r="2.5"/><circle cx="150" cy="42" r="2.5"/><circle cx="160" cy="42" r="2.5"/>
        <!-- West Africa bulge -->
        <circle cx="30" cy="50" r="2.5"/><circle cx="40" cy="50" r="2.5"/><circle cx="50" cy="50" r="2.5"/><circle cx="60" cy="50" r="2.5"/><circle cx="70" cy="50" r="2.5"/><circle cx="80" cy="50" r="2.5"/><circle cx="90" cy="50" r="2.5"/><circle cx="100" cy="50" r="2.5"/><circle cx="110" cy="50" r="2.5"/><circle cx="120" cy="50" r="2.5"/><circle cx="130" cy="50" r="2.5"/><circle cx="140" cy="50" r="2.5"/><circle cx="150" cy="50" r="2.5"/><circle cx="160" cy="50" r="2.5"/><circle cx="170" cy="50" r="2.5"/>
        <circle cx="20" cy="58" r="2.5"/><circle cx="30" cy="58" r="2.5"/><circle cx="40" cy="58" r="2.5"/><circle cx="50" cy="58" r="2.5"/><circle cx="60" cy="58" r="2.5"/><circle cx="70" cy="58" r="2.5"/><circle cx="80" cy="58" r="2.5"/><circle cx="90" cy="58" r="2.5"/><circle cx="100" cy="58" r="2.5"/><circle cx="110" cy="58" r="2.5"/><circle cx="120" cy="58" r="2.5"/><circle cx="130" cy="58" r="2.5"/><circle cx="140" cy="58" r="2.5"/><circle cx="150" cy="58" r="2.5"/><circle cx="160" cy="58" r="2.5"/><circle cx="170" cy="58" r="2.5"/>
        <circle cx="12" cy="66" r="2.5"/><circle cx="22" cy="66" r="2.5"/><circle cx="32" cy="66" r="2.5"/><circle cx="42" cy="66" r="2.5"/><circle cx="52" cy="66" r="2.5"/><circle cx="62" cy="66" r="2.5"/><circle cx="72" cy="66" r="2.5"/><circle cx="82" cy="66" r="2.5"/><circle cx="92" cy="66" r="2.5"/><circle cx="102" cy="66" r="2.5"/><circle cx="112" cy="66" r="2.5"/><circle cx="122" cy="66" r="2.5"/><circle cx="132" cy="66" r="2.5"/><circle cx="142" cy="66" r="2.5"/><circle cx="152" cy="66" r="2.5"/><circle cx="162" cy="66" r="2.5"/><circle cx="172" cy="66" r="2.5"/>
        <!-- Central Africa -->
        <circle cx="20" cy="74" r="2.5"/><circle cx="30" cy="74" r="2.5"/><circle cx="40" cy="74" r="2.5"/><circle cx="50" cy="74" r="2.5"/><circle cx="60" cy="74" r="2.5"/><circle cx="70" cy="74" r="2.5"/><circle cx="80" cy="74" r="2.5"/><circle cx="90" cy="74" r="2.5"/><circle cx="100" cy="74" r="2.5"/><circle cx="110" cy="74" r="2.5"/><circle cx="120" cy="74" r="2.5"/><circle cx="130" cy="74" r="2.5"/><circle cx="140" cy="74" r="2.5"/><circle cx="150" cy="74" r="2.5"/><circle cx="160" cy="74" r="2.5"/><circle cx="170" cy="74" r="2.5"/>
        <circle cx="30" cy="82" r="2.5"/><circle cx="40" cy="82" r="2.5"/><circle cx="50" cy="82" r="2.5"/><circle cx="60" cy="82" r="2.5"/><circle cx="70" cy="82" r="2.5"/><circle cx="80" cy="82" r="2.5"/><circle cx="90" cy="82" r="2.5"/><circle cx="100" cy="82" r="2.5"/><circle cx="110" cy="82" r="2.5"/><circle cx="120" cy="82" r="2.5"/><circle cx="130" cy="82" r="2.5"/><circle cx="140" cy="82" r="2.5"/><circle cx="150" cy="82" r="2.5"/><circle cx="160" cy="82" r="2.5"/>
        <!-- Gulf of Guinea coast -->
        <circle cx="40" cy="90" r="2.5"/><circle cx="50" cy="90" r="2.5"/><circle cx="60" cy="90" r="2.5"/><circle cx="70" cy="90" r="2.5"/><circle cx="80" cy="90" r="2.5"/><circle cx="90" cy="90" r="2.5"/><circle cx="100" cy="90" r="2.5"/><circle cx="110" cy="90" r="2.5"/><circle cx="120" cy="90" r="2.5"/><circle cx="130" cy="90" r="2.5"/><circle cx="140" cy="90" r="2.5"/><circle cx="150" cy="90" r="2.5"/><circle cx="160" cy="90" r="2.5"/>
        <circle cx="50" cy="98" r="2.5"/><circle cx="60" cy="98" r="2.5"/><circle cx="70" cy="98" r="2.5"/><circle cx="80" cy="98" r="2.5"/><circle cx="90" cy="98" r="2.5"/><circle cx="100" cy="98" r="2.5"/><circle cx="110" cy="98" r="2.5"/><circle cx="120" cy="98" r="2.5"/><circle cx="130" cy="98" r="2.5"/><circle cx="140" cy="98" r="2.5"/><circle cx="150" cy="98" r="2.5"/><circle cx="160" cy="98" r="2.5"/><circle cx="170" cy="98" r="2.5"/>
        <!-- Congo / East Africa -->
        <circle cx="60" cy="106" r="2.5"/><circle cx="70" cy="106" r="2.5"/><circle cx="80" cy="106" r="2.5"/><circle cx="90" cy="106" r="2.5"/><circle cx="100" cy="106" r="2.5"/><circle cx="110" cy="106" r="2.5"/><circle cx="120" cy="106" r="2.5"/><circle cx="130" cy="106" r="2.5"/><circle cx="140" cy="106" r="2.5"/><circle cx="150" cy="106" r="2.5"/><circle cx="160" cy="106" r="2.5"/><circle cx="170" cy="106" r="2.5"/>
        <circle cx="65" cy="114" r="2.5"/><circle cx="75" cy="114" r="2.5"/><circle cx="85" cy="114" r="2.5"/><circle cx="95" cy="114" r="2.5"/><circle cx="105" cy="114" r="2.5"/><circle cx="115" cy="114" r="2.5"/><circle cx="125" cy="114" r="2.5"/><circle cx="135" cy="114" r="2.5"/><circle cx="145" cy="114" r="2.5"/><circle cx="155" cy="114" r="2.5"/><circle cx="165" cy="114" r="2.5"/>
        <!-- Tanzania / Mozambique -->
        <circle cx="70" cy="122" r="2.5"/><circle cx="80" cy="122" r="2.5"/><circle cx="90" cy="122" r="2.5"/><circle cx="100" cy="122" r="2.5"/><circle cx="110" cy="122" r="2.5"/><circle cx="120" cy="122" r="2.5"/><circle cx="130" cy="122" r="2.5"/><circle cx="140" cy="122" r="2.5"/><circle cx="150" cy="122" r="2.5"/><circle cx="160" cy="122" r="2.5"/>
        <circle cx="75" cy="130" r="2.5"/><circle cx="85" cy="130" r="2.5"/><circle cx="95" cy="130" r="2.5"/><circle cx="105" cy="130" r="2.5"/><circle cx="115" cy="130" r="2.5"/><circle cx="125" cy="130" r="2.5"/><circle cx="135" cy="130" r="2.5"/><circle cx="145" cy="130" r="2.5"/><circle cx="155" cy="130" r="2.5"/>
        <!-- Zambia / Zimbabwe -->
        <circle cx="80" cy="138" r="2.5"/><circle cx="90" cy="138" r="2.5"/><circle cx="100" cy="138" r="2.5"/><circle cx="110" cy="138" r="2.5"/><circle cx="120" cy="138" r="2.5"/><circle cx="130" cy="138" r="2.5"/><circle cx="140" cy="138" r="2.5"/><circle cx="150" cy="138" r="2.5"/>
        <circle cx="75" cy="146" r="2.5"/><circle cx="85" cy="146" r="2.5"/><circle cx="95" cy="146" r="2.5"/><circle cx="105" cy="146" r="2.5"/><circle cx="115" cy="146" r="2.5"/><circle cx="125" cy="146" r="2.5"/><circle cx="135" cy="146" r="2.5"/><circle cx="145" cy="146" r="2.5"/><circle cx="155" cy="146" r="2.5"/>
        <!-- Botswana / Namibia -->
        <circle cx="70" cy="154" r="2.5"/><circle cx="80" cy="154" r="2.5"/><circle cx="90" cy="154" r="2.5"/><circle cx="100" cy="154" r="2.5"/><circle cx="110" cy="154" r="2.5"/><circle cx="120" cy="154" r="2.5"/><circle cx="130" cy="154" r="2.5"/><circle cx="140" cy="154" r="2.5"/><circle cx="150" cy="154" r="2.5"/>
        <circle cx="65" cy="162" r="2.5"/><circle cx="75" cy="162" r="2.5"/><circle cx="85" cy="162" r="2.5"/><circle cx="95" cy="162" r="2.5"/><circle cx="105" cy="162" r="2.5"/><circle cx="115" cy="162" r="2.5"/><circle cx="125" cy="162" r="2.5"/><circle cx="135" cy="162" r="2.5"/><circle cx="145" cy="162" r="2.5"/>
        <!-- South Africa narrowing -->
        <circle cx="70" cy="170" r="2.5"/><circle cx="80" cy="170" r="2.5"/><circle cx="90" cy="170" r="2.5"/><circle cx="100" cy="170" r="2.5"/><circle cx="110" cy="170" r="2.5"/><circle cx="120" cy="170" r="2.5"/><circle cx="130" cy="170" r="2.5"/><circle cx="140" cy="170" r="2.5"/>
        <circle cx="75" cy="178" r="2.5"/><circle cx="85" cy="178" r="2.5"/><circle cx="95" cy="178" r="2.5"/><circle cx="105" cy="178" r="2.5"/><circle cx="115" cy="178" r="2.5"/><circle cx="125" cy="178" r="2.5"/><circle cx="135" cy="178" r="2.5"/>
        <circle cx="80" cy="186" r="2.5"/><circle cx="90" cy="186" r="2.5"/><circle cx="100" cy="186" r="2.5"/><circle cx="110" cy="186" r="2.5"/><circle cx="120" cy="186" r="2.5"/><circle cx="130" cy="186" r="2.5"/>
        <!-- Cape -->
        <circle cx="85" cy="194" r="2.5"/><circle cx="95" cy="194" r="2.5"/><circle cx="105" cy="194" r="2.5"/><circle cx="115" cy="194" r="2.5"/><circle cx="125" cy="194" r="2.5"/>
        <circle cx="90" cy="202" r="2.5"/><circle cx="100" cy="202" r="2.5"/><circle cx="110" cy="202" r="2.5"/><circle cx="120" cy="202" r="2.5"/>
        <circle cx="95" cy="210" r="2.5"/><circle cx="105" cy="210" r="2.5"/><circle cx="115" cy="210" r="2.5"/>
        <!-- Horn of Africa (right side extension) -->
        <circle cx="175" cy="50" r="2"/><circle cx="180" cy="54" r="2"/><circle cx="185" cy="58" r="2"/><circle cx="188" cy="62" r="2"/>
        <circle cx="175" cy="42" r="2"/><circle cx="180" cy="46" r="2"/>
        <!-- Madagascar -->
        <circle cx="175" cy="130" r="2"/><circle cx="178" cy="138" r="2"/><circle cx="180" cy="146" r="2"/><circle cx="178" cy="154" r="2"/><circle cx="175" cy="162" r="2"/>
      </svg>

      <!-- Timer -->
      <div class="conf-timer-wrap">
        <div id="gettingValuesExample">
          <div class="flip-clock">
            <span class="flip-clock__piece flip">
              <span class="flip-clock__card flip-card">
                <b class="flip-card__top hours">0</b>
              </span>
              <span class="flip-clock__slot">Hours</span>
            </span>
            <span class="flip-clock__piece flip">
              <span class="flip-clock__card flip-card">
                <b class="flip-card__top minutes">0</b>
              </span>
              <span class="flip-clock__slot">minutes</span>
            </span>
            <span class="flip-clock__piece flip">
              <span class="flip-clock__card flip-card">
                <b class="flip-card__top seconds">0</b>
              </span>
              <span class="flip-clock__slot">seconds</span>
            </span>
          </div>
        </div>
      </div>

      <div class="conf-body">
        <!-- <div class="w-full">
          <div class="card-2">
                <div class="card-header-1">
                    <div class="d-flex">
                        <h5 class="card-title flex-grow-1 mb-0"><svg class="inline-block fill-current mdi mdi-truck-fast-outline align-middle me-1 text-muted" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M18 6v-6h-18v18h6v6h18v-18h-6zm-12 10h-4v-14h14v4h-10v10zm16 6h-14v-14h14v14zm-6.793-4v-.757c1.529-1.381 2.425-2.116 2.436-2.896 0-.436-.255-.782-.872-.782-.46 0-.864.23-1.144.437l-.354-.889c.396-.304 1.029-.551 1.745-.551 1.218 0 1.875.708 1.875 1.67 0 1.145-1.043 1.996-1.917 2.724v.016h2.024v1.028h-3.793zm-4.097-3.544h1.11l.624.925.617-.925h1.075l-1.164 1.659 1.31 1.885h-1.11l-.741-1.118-.74 1.118h-1.091l1.275-1.865-1.165-1.679z"/></svg>Double orders</h5>
                        <div class="flex-shrink-0">({{dataDouble.length}})</div>
                    </div>
                </div>
                <div class="card-body-2">
                    <div class="text-center">
                      <svg class="inline-block fill-current mdi mdi-truck-fast-outline align-middle me-1 text-black" xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24"><path d="M18 6v-6h-18v18h6v6h18v-18h-6zm-12 10h-4v-14h14v4h-10v10zm16 6h-14v-14h14v14zm-6.793-4v-.757c1.529-1.381 2.425-2.116 2.436-2.896 0-.436-.255-.782-.872-.782-.46 0-.864.23-1.144.437l-.354-.889c.396-.304 1.029-.551 1.745-.551 1.218 0 1.875.708 1.875 1.67 0 1.145-1.043 1.996-1.917 2.724v.016h2.024v1.028h-3.793zm-4.097-3.544h1.11l.624.925.617-.925h1.075l-1.164 1.659 1.31 1.885h-1.11l-.741-1.118-.74 1.118h-1.091l1.275-1.865-1.165-1.679z"/></svg>
                        <h5 class="fs-16 mt-2">
                          <span v-if="loadingDouble">
                            Checking ...   <div class="facebook-spinner">
                              <div class="spinner-block block-1"></div>
                              <div class="spinner-block block-2"></div>
                              <div class="spinner-block block-3"></div>
                            </div>
                          </span>
                          <span v-else>
                            Number of order doubled by this phone ({{dataDouble.length}}) <span v-if="dataDouble.length>0"><svg @click="$vm2.open('ModalDouble')" class="cursor-pointer  inline-block fill-current mdi mdi-truck-fast-outline align-middle me-1 text-black"  width="24" height="24"   clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m11.998 5c-4.078 0-7.742 3.093-9.853 6.483-.096.159-.145.338-.145.517s.048.358.144.517c2.112 3.39 5.776 6.483 9.854 6.483 4.143 0 7.796-3.09 9.864-6.493.092-.156.138-.332.138-.507s-.046-.351-.138-.507c-2.068-3.403-5.721-6.493-9.864-6.493zm.002 3c2.208 0 4 1.792 4 4s-1.792 4-4 4-4-1.792-4-4 1.792-4 4-4zm0 1.5c1.38 0 2.5 1.12 2.5 2.5s-1.12 2.5-2.5 2.5-2.5-1.12-2.5-2.5 1.12-2.5 2.5-2.5z" fill-rule="nonzero"/></svg></span>
                          </span>
                        </h5>
                        <p class="phone mb-0">Phone number: {{order.customer.phone}}</p>
                    </div>
                </div>
            </div>
        </div> -->
        <!-- Detail Order Cards -->
        <div class="conf-detail-grid">
          <div class="conf-detail-card">
            <div class="conf-detail-icon conf-detail-icon-blue">
              <i class="material-icons">bookmark_border</i>
            </div>
            <div>
              <span class="conf-detail-label">Order ID</span>
              <span class="conf-detail-value">{{'#'+$f.getIdbySplit(order.id)}}</span>
            </div>
          </div>
          <div class="conf-detail-card">
            <div class="conf-detail-icon conf-detail-icon-green">
              <i class="material-icons">event</i>
            </div>
            <div>
              <span class="conf-detail-label">Order Date</span>
              <span class="conf-detail-value">{{ order.date }}</span>
            </div>
          </div>
          <div class="conf-detail-card">
            <div class="conf-detail-icon conf-detail-icon-purple">
              <i class="material-icons">person</i>
            </div>
            <div>
              <span class="conf-detail-label">Seller</span>
              <span class="conf-detail-value" v-if="order && order.seller">{{ order.seller.fullName }}</span>
            </div>
          </div>
          <div class="conf-detail-card">
            <div class="conf-detail-icon conf-detail-icon-orange">
              <i class="material-icons">local_grocery_store</i>
            </div>
            <div>
              <span class="conf-detail-label">Store</span>
              <span class="conf-detail-value">{{ order.source }}</span>
            </div>
          </div>
        </div>

        <!-- ________________________________________________End Detail Order ________________________ -->

        <div class="conf-two-col">
          <div class="conf-col-left">
            <div class="conf-card">
              <div class="conf-card-header">
                <div class="flex items-center flex-wrap gap-2">
                  <h3 class="conf-card-title">Order Products</h3>
                  <!-- UPSELL AVAILABLE BADGE -->
                <span v-if="productUpsellConfig && productUpsellConfig.length > 0 && order.details && order.details.length === 1" 
                      class="ml-2 inline-flex items-center px-2 py-1 rounded-full text-xs font-semibold bg-purple-100 text-purple-700 border border-purple-300 animate-pulse">
                    <span class="mr-1">🎯</span>
                    Upsell disponible ({{ productUpsellConfig.length }})
                </span>
                
                <!-- CROSS-SELL AVAILABLE BADGE -->
                <span v-if="availableCrossSellBundles && availableCrossSellBundles.length > 0" 
                      class="inline-flex items-center px-2 py-1 rounded-full text-xs font-semibold bg-blue-100 text-blue-700 border border-blue-300 animate-pulse">
                    <span class="mr-1">🎁</span>
                    Cross-sell disponible ({{ availableCrossSellBundles.length }})
                </span>
                
                </div>
                <svg @click="EditOrder('open')" class="ml-auto feather cursor-pointer align-sub feather-file-text inline-block ml-2" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M8.424 12.282l4.402 4.399-5.826 1.319 1.424-5.718zm15.576-6.748l-9.689 9.804-4.536-4.536 9.689-9.802 4.536 4.534zm-6 8.916v6.55h-16v-12h6.743l1.978-2h-10.721v16h20v-10.573l-2 2.023z"/></svg>
              </div>

              <!-- Product List -->
              <div class="conf-products-list relative">
                <loading :active.sync="loadingeditOrder" :is-full-page="fullPage"></loading>
                <div v-for="(it, indx) in order.details" :key="it._id" class="conf-product-row">
                  <img :src="it.product.picture||'https://img.icons8.com/external-others-inmotus-design/67/000000/external-Image-basic-ui-elements-others-inmotus-design-3.png'" class="conf-product-img" />
                  <div class="conf-product-info">
                    <span class="conf-product-name">{{ it.product.name }}</span>
                    <span class="conf-product-sub">{{ it.unitPrice.toFixed(2) }} {{ idWharhouse.currency }} x {{ it.quantity }}</span>
                  </div>
                  <div class="conf-product-price">
                    {{ (it.unitPrice * it.quantity).toFixed(2) }} <sup>{{ idWharhouse.currency }}</sup>
                  </div>
                  <div class="conf-product-link">
                    <a v-if="it.product.verificationLink && validURL(it.product.verificationLink)" :href="it.product.verificationLink" target="_blank" class="conf-product-link-btn conf-product-link-active">
                      <i class="material-icons">open_in_new</i>
                    </a>
                    <span v-else class="conf-product-link-btn conf-product-link-none">N/A</span>
                  </div>
                </div>
              </div>

              <!-- Cross-sell / Upsell indicators -->
              <div v-if="isCrossSell && matchedCrossSellBundle" class="conf-sell-indicator conf-sell-cross">
                <div class="conf-sell-indicator-left">
                  <span class="conf-sell-indicator-icon">🎁</span>
                  <div>
                    <span class="conf-sell-indicator-title">Cross-sell Bundle</span>
                    <span class="conf-sell-indicator-sub">{{ matchedCrossSellBundle.length }} produits</span>
                  </div>
                </div>
                <div class="conf-sell-indicator-right">
                  <span class="conf-sell-indicator-old">{{ calculateNormalTotal() }} {{ idWharhouse.currency }}</span>
                  <span class="conf-sell-indicator-new">{{ crossSellPrice }} {{ idWharhouse.currency }}</span>
                </div>
              </div>

              <div v-if="isUpsell && upsellPrice > 0" class="conf-sell-indicator conf-sell-upsell">
                <div class="conf-sell-indicator-left">
                  <span class="conf-sell-indicator-icon">🎯</span>
                  <div>
                    <span class="conf-sell-indicator-title">Upsell</span>
                    <span class="conf-sell-indicator-sub">+{{ getUpsellQuantityAdded() }} unit&eacute;(s)</span>
                  </div>
                </div>
                <div class="conf-sell-indicator-right">
                  <span class="conf-sell-indicator-old">{{ calculateNormalTotal() }} {{ idWharhouse.currency }}</span>
                  <span class="conf-sell-indicator-new">{{ upsellPrice }} {{ idWharhouse.currency }}</span>
                  <span v-if="upsellCommission > 0" class="conf-sell-indicator-commission">+{{ upsellCommission }} {{ idWharhouse.currency }}</span>
                </div>
              </div>

              <!-- Total -->
              <div class="conf-total-bar">
                <span class="conf-total-label">Total</span>
                <div class="conf-total-right">
                  <span v-if="(isUpsell && upsellPrice > 0) || (isCrossSell && crossSellPrice > 0)" class="conf-total-old">
                    {{ calculateNormalTotal() }} {{ idWharhouse.currency }}
                  </span>
                  <span class="conf-total-value" :class="{ 'conf-total-upsell': isUpsell && upsellPrice > 0, 'conf-total-cross': isCrossSell && crossSellPrice > 0 }">
                    {{ TotalPrice() }} <sup>{{ idWharhouse.currency }}</sup>
                  </span>
                  <span v-if="isUpsell" class="conf-total-badge conf-total-badge-purple">UPSELL</span>
                  <span v-if="isCrossSell" class="conf-total-badge conf-total-badge-blue">CROSS-SELL</span>
                </div>
              </div>
            </div>
          </div>

          <!-- __________________________________________________________End Product Order __________________________________________ -->
          <!-- __________________________________________________________Debut Customer Information ________________________________ -->

          <div class="conf-col-right">
            <div class="conf-card">
              <div class="conf-card-header">
                <h3 class="conf-card-title">Customer Information</h3>
              </div>
              <div class="conf-customer-body">
                <!-- Phone highlight -->
                <div class="conf-customer-phone-card">
                  <div class="conf-customer-phone-icon">
                    <i class="material-icons">phone_in_talk</i>
                  </div>
                  <div class="conf-customer-phone-info">
                    <span class="conf-customer-phone-label">Phone Number</span>
                    <span class="conf-customer-phone-value">{{ order.customer.phone }}</span>
                  </div>
                </div>

                <!-- Fields -->
                <div class="conf-customer-fields">
                  <div class="conf-customer-field">
                    <label class="conf-customer-field-label">Full Name</label>
                    <div class="conf-customer-field-input">
                      <i class="material-icons conf-customer-field-icon">person_outline</i>
                      <input type="text" disabled v-model="order.customer.fullName" placeholder="Full Name" />
                    </div>
                  </div>
                  <div class="conf-customer-field">
                    <label class="conf-customer-field-label">Address</label>
                    <div class="conf-customer-field-input">
                      <i class="material-icons conf-customer-field-icon">location_on</i>
                      <textarea disabled v-model="order.customer.address" placeholder="Address" rows="2"></textarea>
                    </div>
                  </div>
                </div>
                      <!-- *************************************************END FULL NAME && Address ********************************-->
                      <!-- *************************************************Debut section Phone ********************************-->
                    
            
                      
                  <!--    <div
                        class="border hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1"
                        :class="
                          style
                            ? 'py-1 px-1 text-sm outline-none block h-full w-full focus:outline-none border-blue-500 hover:border-blue-600'
                            : 'py-1 px-1 text-sm outline-none block h-full w-full focus:outline-none'
                        "
                      >
                        <div
                          class="-mt-4 absolute tracking-wider px-1 uppercase text-xs"
                        >
                          <p>
                            <label
                              for="password"
                              class="capitalize bg-white text-gray-600 px-1"
                              >Date shipping *</label
                            >
                          </p>
                        </div>
                        <p>
                          <input
                            type="date"
                            placeholder="Telephone"
                            disabled
                            v-model="shipping.date"
                            :class="
                              style
                                ? 'py-1 px-1 text-sm outline-none block h-full w-full focus:outline-none border-blue-500 hover:border-blue-600'
                                : 'py-1 px-1 text-sm outline-none block h-full w-full focus:outline-none'
                            "
                          />
                        </p>
                      </div>-->
                      <!-- *************************************************END section Phone ********************************-->
              </div>
            </div>
          </div>
          <!-- __________________________________________________________End Customer __________________________________________ -->
        </div>
        <!-- ______________________________________________________________Debut section Button ____________________________ -->

        <!-- Out of Stock Alert -->
        <div v-if="checkOutOfstock.action && checkOutOfstock.type=='outofstock'" class="conf-alert-stock">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"/></svg>
          <div>
            <span class="font-semibold">{{checkOutOfstock.message}}</span>
            <span class="conf-alert-stock-info">Instock: {{checkOutOfstock.stock}}</span>
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="conf-actions">
          <button v-if="checkOutOfstock.action && checkOutOfstock.type=='outofstock'"
            @click="skipOrder(order)"
            class="conf-action-btn conf-action-skip relative loidingconfirm" :class="loading?'noselect':''">
            <loading :active.sync="loading" :is-full-page="fullPage"></loading>
            <i class="material-icons">skip_next</i>
            <span>Skip</span>
          </button>
          <button @click="$vm2.open('modal-confirm')" class="conf-action-btn conf-action-confirm">
            <i class="material-icons">check_circle</i>
            <span>Confirm</span>
          </button>
          <button @click="$vm2.open('myModalUnrached')" class="conf-action-btn conf-action-unreached">
            <i class="material-icons">phone_missed</i>
            <span>Unreached</span>
          </button>
          <button @click="$vm2.open('myModalRemonded')" class="conf-action-btn conf-action-remind">
            <i class="material-icons">schedule</i>
            <span>A rapeller</span>
          </button>
          <button @click="OrangeOrderStatus(order,'En attente de dépot')" class="conf-action-btn conf-action-depot">
            <i class="material-icons">move_to_inbox</i>
            <span>En attente de d&eacute;pot</span>
          </button>
          <button @click="$vm2.open('myModalCancel')" class="conf-action-btn conf-action-cancel">
            <i class="material-icons">cancel</i>
            <span>Cancelled</span>
          </button>
        </div>
        <!-- _______________________________________________Fin ______________________________ -->
        <!-- ____________________________________Debut section PopUp Confirmation _________________ -->
        <vue-modal-2 name="modal-confirm" :headerOptions="{title: 'Confirmation Order'}" :noFooter="true" modalSize="lg">
           <div>
              <div class="p-4 pt-0 relative">
              <loading :active.sync="loading" :is-full-page="fullPage"></loading>
                  <div>
                      <div class="flex flex-col md:flex-row">
                          <div class="w-full mx-2 flex-1 svelte-1l8159u">
                              <label for="shipp-date" class="font-bold h-6 mt-3 text-gray-600 text-xs leading-8 uppercase"> Shipping Date</label>                 
                              <!-- <datetime-v2  v-model="shipping.date" placeholder="Shipping Date ..." input-class="shadow appearance-none border rounded w-full py-3 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" ></datetime-v2>  -->
                             <div class="shippDate shadow appearance-none border rounded w-full text-gray-700 leading-tight focus:outline-none focus:shadow-outline">
                                <date-picker v-model="shipping.date" format="YYYY-MM-DD" type="date" placeholder="Shipping Date ..."></date-picker>
                             </div>

                  
        
                            <template v-if="checkWarehousingParent.length === 0">
                              <label class="font-bold h-6 mt-3 text-gray-600 text-xs leading-8 uppercase"> Zone</label>
                             <div class="shadow bg-white mt-0 my-2 p-1 flex border border-gray-200 rounded svelte-1l8159u">
                                  <v-select label="name" placeholder="Zone ...."  @search="serchZones($event,'zone')" v-model="shipping.zone" :options="zones"></v-select>
                             </div>

                            </template> 
                            <template v-else>
                              <label class="font-bold h-6 mt-3 text-gray-600 text-xs leading-8 uppercase"> Zone (City)</label>
                             <div class="shadow bg-white mt-0 my-2 p-1 flex border border-gray-200 rounded svelte-1l8159u">
                                  <v-select label="name" placeholder="City ...." v-model="shipping.warehouseParent" :options="checkWarehousingParent"></v-select>
                             </div>

                            </template> 
                             
                            
                          </div>
                          <div class="w-full mx-2 flex-1 svelte-1l8159u">
                              <label class="font-bold h-6 mt-3 text-gray-600 text-xs leading-8 uppercase"> Phone 2</label>
                             <input type="tel"  placeholder="Telephone" v-model="order.customer.shippingPhone" class="shadow appearance-none border rounded w-full py-3 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"> 
                           
                             
                           <!--   <label class="font-bold h-6 mt-3 text-gray-600 text-xs leading-8 uppercase"> Courier</label>
                              <div class="shadow bg-white my-2 p-1 flex border border-gray-200 rounded svelte-1l8159u">
                                  <v-select label="email" v-model="shipping.courrier" :options="courier"></v-select>
                             </div>-->
                    
                          </div>
                      </div>
                  <div class="w-full mx-2 flex-1">
                    <div class="mr-5">
                      <label for="shipp-add" class="font-bold h-6 text-gray-600 text-xs leading-8 uppercase"> shipping Address</label>
                      <textarea id="shipp-add" v-model="order.customer.shippingAddress"  cols="10" rows="3" placeholder="Shipping Address.." class="my-2 mt-0 p-1 shadow appearance-none border rounded w-full py-3 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"></textarea> 
                    </div>   
                  </div>    
                  <div class="w-full mx-2 flex-1">
                      <label class="font-bold h-6 mt-3 text-gray-600 text-xs leading-8 uppercase"> Add Comment</label>
                    <div class="mr-5">
                                  <textarea
                      id="commentConfirmation"
                      cols="10"
                      rows="3"
                      placeholder="Comment ..."
                      v-model="order.comment"
                      class="my-2 mt-0 p-1 shadow appearance-none border rounded w-full py-3 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                      ></textarea>
                    </div>
                  </div>
                  </div>
                  <div class="flex p-2 mt-4">
                      <div class="flex-auto flex flex-row-reverse">
                          <button :disabled="loading" @click="ConfirmOrderStatus(order)" class="w-1/6 p-3 btn-action rounded bg-blue-600 hover:bg-blue-500 text-white font-semibold focus:outline-none">Confirm</button>
                          <button :disabled="loading"  @click="CloseModal('modal-confirm')" class="w-1/6 p-3 mr-4 rounded bg-gray-600 hover:bg-gray-500 text-white font-semibold focus:outline-none">Annuler</button>
                      </div>
                  </div>
              </div>
          </div>
        </vue-modal-2>
        <!-- ___________________________________________________________Debut section PopUp _________________ -->

        <!-- ____________________________________Debut section PopUp Cancelled ___---------______________ -->
        <vue-modal-2 name="myModalCancel" :headerOptions="{title: 'Cancelation Order'}" :noFooter="true" modalSize="lg">
             <div class="flex flex-col w-full h-auto">
            <!-- Header -->
          
            <!-- Modal Content-->
            <div
              class="flex w-full relative h-auto justify-center items-center rounded text-center text-gray-600"
            >
             <loading :active.sync="loading" :is-full-page="fullPage"></loading>
              <div class="w-full bg-white px-6 pb-2  relative">
                <textarea
                  style="border-color: #a7adb3;border-width: 2px;"
                  id="commentConfir"
                  cols="10"
                  rows="3"
                  placeholder="Reason for cancellation"
                  v-model="motifAnnulation"
                  class="border p-2 mt-3 w-full focus:outline-none hover:border-blue-600"
                ></textarea>
                
                <div class="flex p-2 mt-4">
                      <div class="flex-auto flex flex-row-reverse">
                          <button :disabled="loading" @click="cancelOrder(order)" class="w-1/3 p-3 btn-action rounded bg-blue-600 hover:bg-blue-500 text-white font-semibold focus:outline-none"> Cancel Order</button>
                          <button :disabled="loading"  @click="CloseModal('myModalCancel')" class="w-1/3 p-3 mr-4 rounded bg-gray-600 hover:bg-gray-500 text-white font-semibold focus:outline-none">Annuler</button>
                      </div>
                  </div>

              </div>
            </div>
            <!-- End of Modal Content-->
          </div>
        </vue-modal-2>


        <vue-modal-2 name="myModalRemonded" :headerOptions="{title: 'A Rapeller order'}" :noFooter="true" modalSize="lg">
           <div class="relative flex flex-col w-full h-auto">
            <loading :active.sync="loading" :is-full-page="fullPage"></loading>
            <!-- Header -->
            <!-- Modal Content-->
            <div class="bg-white rounded px-8 pb-2 flex flex-col">
              <label class="block text-grey-darker text-sm font-bold mb-2" for="dateremind">A Rapeller date</label>
             <!-- <datetime-v2 type="datetime" v-model="remindDate"
               placeholder="Remind date" input-class="focus:outline-none shadow appearance-none border rounded w-full py-2 px-3 text-grey-darker" ></datetime-v2> -->
            <div class="shippDate shadow appearance-none border rounded w-full text-gray-700 leading-tight focus:outline-none focus:shadow-outline">
                 <date-picker v-model="remindDate" format="YYYY-MM-DD hh:mm" type="datetime" placeholder="A Rapeller Date ..."></date-picker>
            </div>
              <div class="my-4">
                <label class="block text-grey-darker text-sm font-bold" for="content">Message</label>
                  <textarea
                    id="content"
                    cols="10"
                    rows="3"
                    placeholder="Message ..."
                    v-model="contentRemend"
                    class="focus:outline-none shadow appearance-none border border-red rounded w-full py-2 px-3 text-grey-darker mb-3"
                  ></textarea>
              </div>
             
            <div class="flex p-2">
                      <div class="flex-auto flex flex-row-reverse">
                          <button :disabled="loading" @click="RemindOrder(order)" class="w-1/3 p-3 btn-action rounded bg-blue-600 hover:bg-blue-500 text-white font-semibold focus:outline-none"> Confirm</button>
                          <button :disabled="loading"  @click="CloseModal('myModalRemonded')" class="w-1/3 p-3 mr-4 rounded bg-gray-600 hover:bg-gray-500 text-white font-semibold focus:outline-none">Annuler</button>
                      </div>
            </div>
            </div>
            <!-- End of Modal Content-->
          </div>
        </vue-modal-2>
       
          <vue-modal-2 name="myModalUnrached" :headerOptions="{title: 'Unreached Order'}" :noFooter="true" modalSize="lg">
            <div class="flex flex-col w-full h-auto">
            <!-- Header -->
            <!-- Modal Content-->
            <div class="bg-white rounded px-8  pb-2 flex flex-col">
               <loading :active.sync="loading" :is-full-page="fullPage"></loading>
                <div class="my-6 mt-4">
                  <div class="border seller-select h-10 hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                      <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                          <p>
                            <label for="seller" class="bg-white text-gray-700 px-1"> Reason unreached
                            <span :class="$colors.required">*</span></label>
                          </p>
                      </div>    
                      <p>
                          <v-select  v-model="motifUnrached" :options="commentsUnrach"></v-select>
                      </p>     
                  </div> 
                </div>
                
                <div class="flex p-2 mt-4">
                      <div class="flex-auto flex flex-row-reverse">
                          <button :disabled="loading" @click="UnreachedOrder(order)" class="w-1/3 p-3 btn-action rounded bg-blue-600 hover:bg-blue-500 text-white font-semibold focus:outline-none"> Confirm</button>
                          <button :disabled="loading"  @click="CloseModal('myModalUnrached')" class="w-1/3 p-3 mr-4 rounded bg-gray-600 hover:bg-gray-500 text-white font-semibold focus:outline-none">Annuler</button>
                      </div>
                  </div>
            </div>
            <!-- End of Modal Content-->
          </div>
         </vue-modal-2>

         <vue-modal-2 name="myModalDepot" :headerOptions="{title: 'En attente de dépôt'}" :noFooter="true" modalSize="md">
            <div class="flex flex-col w-full h-auto">
            <!-- Header -->
            <!-- Modal Content-->
            <div class="bg-white rounded px-2  pb-2 flex flex-col">
               <loading :active.sync="loading" :is-full-page="fullPage"></loading>
                <p class="font-bold text-center">Etes-vous sûr de changer la commande en En attente de dépôt ?</p>
                
                <div class="flex p-2 mt-4">
                      <div class="flex-auto flex flex-row-reverse">
                          <button :disabled="loading" @click="OrangeOrderStatus(order,'En attente de dépot')" class="w-1/3 p-3 btn-action rounded bg-blue-600 hover:bg-blue-500 text-white font-semibold focus:outline-none"> Confirm</button>
                          <button :disabled="loading"  @click="CloseModal('myModalDepot')" class="w-1/3 p-3 mr-4 rounded bg-gray-600 hover:bg-gray-500 text-white font-semibold focus:outline-none">Annuler</button>
                      </div>
                  </div>
            </div>
            <!-- End of Modal Content-->
          </div>
         </vue-modal-2>

            <!--Edit order-->
            <vue-modal-2 name="EditOrder" :headerOptions="{title: `Edit order`}" :noFooter="true" modalSize="lg">
                <div class="rounded-lg mb-14">
                    <div class="flex flex-col border border-gray-500 px-3 mx-3 p-4 rounded-lg relative">
                       
                        <loading :active.sync="loading" :is-full-page="fullPage"></loading>
                        <div  style="overflow-x: auto;">
                            
                             <div class="w-full data-ss">
                                <div class="header-1">
                                    <div class="content border border-gray-700 border-dashed rounded min-w-125px py-3 px-4 mb-3">
                                        <span class="title">Orders details</span>
                                        <div class="content-1">TotalPrice: {{TotalPrice()}} <sup>{{idWharhouse.currency}}</sup></div>
                                   </div>
                                </div>
<!-- ================================================
     UPSELL & CROSS-SELL OFFERS SECTION
     (Only ONE can be active at a time)
     ================================================ -->
<div class="offers-section mb-4 w-full">
    
    <!-- UPSELL TIERS (Only show if NOT cross-sell active AND single product) -->
    <div v-if="!isCrossSell && productUpsellConfig && productUpsellConfig.length > 0 && order.details.length === 1" 
         class="upsell-card mb-4">
        <div class="card-header bg-gradient-to-r from-purple-600 to-purple-400 text-white px-4 py-2 rounded-t-lg flex items-center">
            <span class="text-xl mr-2">🎯</span>
            <span class="font-bold">Offres Upsell Disponibles</span>
            <span class="ml-auto bg-white text-purple-600 px-2 py-1 rounded-full text-xs font-bold">
                {{ productUpsellConfig.length }} offre(s)
            </span>
        </div>
        <div class="card-body bg-purple-50 border border-purple-200 border-t-0 rounded-b-lg p-4">
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                <div v-for="(tier, idx) in productUpsellConfig" :key="'upsell-'+idx"
                     class="upsell-tier-card p-3 rounded-lg cursor-pointer transition-all duration-200 hover:shadow-lg"
                     :class="order.details[0].quantity === tier.quantity ? 
                             'bg-purple-600 text-white shadow-lg transform scale-105' : 
                             'bg-white border-2 border-purple-200 hover:border-purple-400'"
                     @click="applyUpsellTier(tier)">
                    
                    <!-- Quantity Badge -->
                    <div class="flex items-center justify-between mb-2">
                        <span class="text-xs font-semibold px-2 py-1 rounded-full"
                              :class="order.details[0].quantity === tier.quantity ? 
                                      'bg-white text-purple-600' : 'bg-purple-100 text-purple-600'">
                            QTY: {{ tier.quantity }}
                        </span>
                        <span v-if="order.details[0].quantity === tier.quantity" 
                              class="text-xs bg-green-400 text-white px-2 py-1 rounded-full">
                            ✓ Actif
                        </span>
                    </div>
                    
                    <!-- Price -->
                    <div class="text-center my-2">
                        <span class="text-2xl font-bold">{{ tier.price }}</span>
                        <sup class="text-sm ml-1">{{ idWharhouse.currency }}</sup>
                    </div>
                    
                    <!-- Commission Badge -->
                    <div v-if="tier.commission" class="text-center">
                        <span class="text-xs px-2 py-1 rounded-full"
                              :class="order.details[0].quantity === tier.quantity ? 
                                      'bg-green-400 text-white' : 'bg-green-100 text-green-600'">
                            💰 +{{ tier.commission }} {{ idWharhouse.currency }} commission
                        </span>
                    </div>
                    
                    <!-- Click hint -->
                    <div v-if="order.details[0].quantity !== tier.quantity" 
                         class="text-center mt-2 text-xs text-purple-400">
                        Cliquer pour appliquer
                    </div>
                </div>
            </div>
            
            <!-- Active Upsell Indicator -->
            <div v-if="isUpsell" class="mt-4 p-3 bg-purple-100 border border-purple-300 rounded-lg">
                <div class="flex items-center justify-between">
                    <div class="flex items-center">
                        <span class="text-purple-600 font-bold">✓ Upsell Actif</span>
                        <span class="ml-2 text-sm text-purple-500">
                            (Qty: {{ order.details[0].quantity }} → {{ upsellPrice }} {{ idWharhouse.currency }})
                        </span>
                    </div>
                    <button @click="cancelUpsell" 
                            class="px-3 py-1 bg-red-500 text-white text-xs rounded-full hover:bg-red-600 transition-colors">
                        ✕ Annuler Upsell
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- CROSS-SELL BUNDLES (Only show if NOT upsell active OR multiple products) -->
    <div v-if="!isUpsell && availableCrossSellBundles && availableCrossSellBundles.length > 0" 
         class="crosssell-card">
        <div class="card-header bg-gradient-to-r from-blue-600 to-blue-400 text-white px-4 py-2 rounded-t-lg flex items-center">
            <span class="text-xl mr-2">🎁</span>
            <span class="font-bold">Offres Cross-sell Disponibles</span>
            <span class="ml-auto bg-white text-blue-600 px-2 py-1 rounded-full text-xs font-bold">
                {{ availableCrossSellBundles.length }} bundle(s)
            </span>
        </div>
        <div class="card-body bg-blue-50 border border-blue-200 border-t-0 rounded-b-lg p-4">
            <div class="space-y-3">
                <div v-for="(bundle, idx) in availableCrossSellBundles" :key="'bundle-'+idx"
                     class="bundle-card p-4 rounded-lg transition-all duration-200 hover:shadow-lg cursor-pointer"
                     :class="isBundleMatched(bundle) ? 
                             'bg-green-100 border-2 border-green-500 shadow-lg' : 
                             'bg-white border-2 border-blue-200 hover:border-blue-400'"
                     @click="applyCrossSellBundle(bundle)">
                    
                    <div class="flex flex-wrap items-center justify-between">
                        <!-- Bundle Info -->
                        <div class="flex-1">
                            <div class="flex items-center mb-2">
                                <span class="font-bold text-gray-700 mr-2">Bundle {{ idx + 1 }}</span>
                                <span v-if="isBundleMatched(bundle)" 
                                      class="bg-green-500 text-white text-xs px-2 py-1 rounded-full animate-pulse">
                                    ✓ MATCHED!
                                </span>
                            </div>
                            
                            <!-- Products in Bundle -->
                            <div class="flex flex-wrap items-center gap-2">
                                <template v-for="(item, itemIdx) in bundle">
                                    <div :key="'item-'+itemIdx" 
                                         class="flex items-center bg-gray-100 rounded-lg px-3 py-2">
                                        <div class="w-8 h-8 bg-blue-200 rounded-full flex items-center justify-center mr-2">
                                            <span class="text-blue-600 font-bold text-xs">{{ itemIdx + 1 }}</span>
                                        </div>
                                        <div>
                                            <div class="text-sm font-medium text-gray-800">
                                                {{ getProductNameById(item.product) }}
                                            </div>
                                            <div class="text-xs text-blue-600 font-semibold">
                                                Quantité: {{ item.quantity }}
                                            </div>
                                        </div>
                                    </div>
                                    <span v-if="itemIdx < bundle.length - 1" 
                                          :key="'plus-'+itemIdx" 
                                          class="text-2xl text-gray-400 font-light">+</span>
                                </template>
                            </div>
                        </div>
                        
                        <!-- Price Section -->
                        <div class="text-right ml-4 mt-2 md:mt-0">
                            <div class="text-xs text-gray-500 mb-1">Prix Bundle</div>
                            <div class="flex items-center justify-end">
                                <span class="text-3xl font-bold"
                                      :class="isBundleMatched(bundle) ? 'text-green-600' : 'text-blue-600'">
                                    {{ calculateCrossSellPrice(bundle) }}
                                </span>
                                <sup class="text-sm ml-1 text-gray-500">{{ idWharhouse.currency }}</sup>
                            </div>
                            <div v-if="!isBundleMatched(bundle)" class="text-xs text-blue-400 mt-1">
                                Cliquer pour ajouter
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <!-- Active Cross-sell Indicator -->
            <div v-if="isCrossSell" class="mt-4 p-3 bg-green-100 border border-green-300 rounded-lg">
                <div class="flex items-center justify-between">
                    <div class="flex items-center">
                        <span class="text-green-600 font-bold">✓ Cross-sell Actif</span>
                        <span class="ml-2 text-sm text-green-500">
                            (Bundle: {{ crossSellPrice }} {{ idWharhouse.currency }})
                        </span>
                    </div>
                    <button @click="cancelCrossSell" 
                            class="px-3 py-1 bg-red-500 text-white text-xs rounded-full hover:bg-red-600 transition-colors">
                        ✕ Annuler Cross-sell
                    </button>
                </div>
            </div>
        </div>
    </div>
    
    <!-- SHOW WHICH OFFER IS ACTIVE (when one is selected) -->
    <div v-if="isUpsell || isCrossSell" class="mt-4 p-4 rounded-lg"
         :class="isUpsell ? 'bg-purple-100 border-2 border-purple-400' : 'bg-blue-100 border-2 border-blue-400'">
        <div class="flex items-center justify-between">
            <div>
                <span class="text-lg font-bold" :class="isUpsell ? 'text-purple-700' : 'text-blue-700'">
                    {{ isUpsell ? '🎯 UPSELL APPLIQUÉ' : '🎁 CROSS-SELL APPLIQUÉ' }}
                </span>
                <div class="text-sm mt-1" :class="isUpsell ? 'text-purple-600' : 'text-blue-600'">
                    <span v-if="isUpsell">
                        Quantité: {{ order.details[0].quantity }} | Prix: {{ upsellPrice }} {{ idWharhouse.currency }}
                        <span v-if="upsellCommission > 0"> | Commission: +{{ upsellCommission }} {{ idWharhouse.currency }}</span>
                    </span>
                    <span v-else>
                        {{ order.details.length }} produit(s) | Prix Bundle: {{ crossSellPrice }} {{ idWharhouse.currency }}
                    </span>
                </div>
            </div>
            <button @click="isUpsell ? cancelUpsell() : cancelCrossSell()" 
                    class="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors flex items-center">
                <svg class="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"/>
                </svg>
                Annuler
            </button>
        </div>
    </div>
    
    <!-- NO OFFERS MESSAGE -->
    <div v-if="(!productUpsellConfig || productUpsellConfig.length === 0) && 
               (!availableCrossSellBundles || availableCrossSellBundles.length === 0)"
         class="text-center py-4 text-gray-400">
        <span class="text-2xl">📦</span>
        <p class="mt-2">Aucune offre upsell/cross-sell disponible pour ce produit</p>
    </div>
</div>

                                <div class="header-table th-header">
                                    <div class="w-1/2"><div class="title">Product name</div></div>
                                    <div class="x8yj6t55"><div class="title">Quantity</div></div>
                                    <div class="x8yj6t55"><div class="title">Unit Price</div></div>
                                    <div class="x8yj6t5"><div class="title">Total</div></div>
                                    <div class="x8yj6t5"><div class="title">Action</div></div>
                                </div>
                       
                                <div v-for="(item, index) in order.details" :key="index" class="header-table">
                                    <div class="w-1/2"><div class="title title-1">{{item.product.name}}</div></div>
                                    <div class="x8yj6t55"><div class="title title-1 justify-center">
                                      <div class="flex space-x-6">
                                          <button :class="$colors.textPrimary" class="bg-blue-500 rounded-md w-6 h-6 flex items-center focus:outline-none" @click="addQuantity(index)"><span class="font-bold text-2xl text-white"><i class="material-icons mt-2">add</i></span></button>
                                          <span :class="$colors.textPrimary" class="text-gray-700 text-sm h-6 flex items-center quant focus:outline-none"><input class="focus:outline-none w-12 text-center" type="text" v-model="item.quantity"/></span>
                                          <button :class="$colors.textPrimary" @click="removeQuantity(index)" class="bg-blue-500 quant rounded-md w-6 h-6 text-white flex items-center focus:outline-none"><span class="font-bold text-2xl text-white mt-1"><i class="material-icons">remove</i></span></button>
                                      </div>
                                      <div class="text-xs leading-5 capitalize px-2 rounded-full text-gray-900"></div>
                                    </div></div>
                                    <div class="x8yj6t55"><div class="title title-1"> <div><input disabled autocomplete="false" tabindex="0" min="0" type="number" v-model="item.unitPrice" class="border border-blue-600 py-2 text-xs px-2 outline-none block h-full w-full"/></div></div></div>
                                    <div class="x8yj6t5"><div class="title title-1 justify-center">{{ item.unitPrice * item.quantity }} </div></div>
                                    <div class="x8yj6t5"><div class="title title-1 justify-center"><div class="flex justify-center"><button @click="removeProduct(item, index)" :class="$colors.actionTable" class="rounded-full flex focus:outline-none w-8 h-8 mr-3 mt-1"><i class="material-icons mx-1">delete</i></button></div></div></div>
                                </div>
                                <div class="header-tabl app-theme"><div class="w-full"><div class="title title-1 pt-2"><button @click="EditOrder('products')" id="invoice-item-add" title="Add Item" class="btn btn-prime"><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="plus" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-plus fa-w-14 "><path fill="currentColor" d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"></path></svg></button></div></div></div>
                             </div>
                        </div>  
                    </div>
                    <div class="p-4 flex space-x-4 modal-footer">
                        <a href="#" @click="CloseModal('EditOrder')" class="w-1/2 px-4 py-3 text-center bg-gray-500 text-white hover:bg-gray-400  font-bold rounded-lg text-sm" :class="loading?'noselect':''">Annuler</a>
                        <a href="#" @click="EditOrder('edit')" class="w-1/2 px-4 py-3 text-center text-blue-100 bg-blue-600 rounded-lg hover:bg-blue-700 hover:text-white font-bold text-sm relative loidingconfirm" :class="loading?'noselect':''"><loading :active.sync="loading" :is-full-page="fullPage"></loading> Confirm update</a>
                    </div>
                </div>
            </vue-modal-2>     

            <vue-modal-2 class="moukhtar"  name="ModalProducts" :headerOptions="{title: 'Add Products'}" :noFooter="true" modalSize="lg" @on-close="CloseModal('ModalProducts')">
                <div class="flex flex-col w-full h-auto p-5 pt-0  bottom_bitt">
                  <!-- Header -->
                  <div class="flex w-full h-auto justify-center items-center">
                    <div
                      class="flex w-full h-auto py-3 justify-center items-center text-2xl font-bold"
                    >
                      <span
                        class="w-screen md:w-full h-10 cursor-pointer border border-gray-500 rounded text-sm flex"
                      >
                        <input
                          type="search"
                          name="search"
                          v-model="searchText"
                          placeholder="Search"
                          class="flex-grow px-4 rounded-l-full rounded-r-full text-sm focus:outline-none"
                        />
                        <i class="material-icons text-blue-400 m-2 mr-5 text-lg w-4 h-4"
                          >search</i
                        >
                      </span>
                    </div>
                  </div>
                    <div v-if="products.length <= 0" class="py-2">
                      <span
                        class="w-full flex justify-center text-center py-20 border-b border-gray-500 text-base"
                      >
                        <p class="font-semibold flex text-blue-500 whitespace-no-wrap">
                          <span class="">No Products found </span>
                        </p>
                      </span>
                    </div>
                    <table class="table table-report sm:mt-2 table-p">
                        <tr class="intro-x" v-for="(item, index) in resultSearchUsers"  :key="index" :value="item._id">
                          <td class="w-10 border-b border-t border-l border-gray-500"><input type="checkbox" class="form-checkbox order h-5 w-5 text-blue-500 border-gray-500" @change="addProductsToTemp(item)" v-model="item.check"/></td>
                          <td class="w-10 border-b border-t border-gray-500"><div class="flex"><div class="w-10 h-10 flex-none image-fit rounded-md overflow-hidden"><img :alt="item.name" :src="item.picture||'https://storeino.b-cdn.net/dev/templates/images/no-image.jpeg'"></div></div></td>
                          <td class="border-b border-t border-r border-gray-500"><a href="" class="font-medium whitespace-nowrap">{{ item.name }}</a><div class="text-gray-600 text-xs whitespace-nowrap mt-0.5">{{ exceptDes(item.description) }}</div></td>
                        
                        </tr>
                    </table>  
                </div>

                <div class="modal-footer px-5 border0-t text-right">
                  <button
                    @click="CloseModal('ModalProducts')"
                    class="flex text-white mx-auto max-w-sm rounded text-center bg-gray-500 py-2 px-8 items-center focus:outline-none md:float-right"
                  >
                  Annuler
                  </button>
                  <button
                    @click="EditOrder('addProduct')"
                    class="flex mr-2 text-white mx-auto max-w-sm rounded text-center bg-blue-500 py-2 px-8 items-center focus:outline-none md:float-right"
                  >
                    Confirm
                  </button>
                </div>
          </vue-modal-2>
          <vue-modal-2 class="moukhtar"  name="ModalDouble" :headerOptions="{title: 'Double orders'}" :noFooter="true" modalSize="xl" @on-close="CloseModal('ModalDouble')">
            <div class="flex flex-col w-full h-auto p-5 pt-0  bottom_bitt">
                <div class="align-middle inline-block min-w-full overflow-hidden bg-white shadow-dashboard rounded-bl-lg rounded-br-lg">
                <table class="min-w-full">
                    <thead>
                        <tr>
                            <th class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left leading-4  text-blue-600  tracking-wider">ID order</th>
                            <th class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4  text-blue-600  tracking-wider">Customer</th>
                            <th class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4  text-blue-600  tracking-wider">Products</th>
                            <th class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4  text-blue-600  tracking-wider">Total price</th>
                            <th class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-left text-sm leading-4  text-blue-600  tracking-wider">Status</th>
                            <th class="px-3 py-1 siz12 bg-gray-200 border-b-2 border-t-2 border-gray-300 text-right text-sm leading-4  text-blue-600  tracking-wider">Action</th>
                            
                        </tr>
                    </thead>
                        <tbody class="bg-white">
                        <tr v-for="(order,ind) in dataDouble" :key="ind">
                            <td class="border-t-2 border-gray-300 px-3 py-1">
                                <div class="flex items-center">
                                    <div>
                                        <div class="text-sm leading-5 text-gray-800">{{$f.getIdbySplit(order.id)}}</div>
                                    </div>
                                </div>
                            </td>
                            <td class="border-t-2 border-gray-300 px-3 py-1">
                                <div class="text-sm leading-5 siz12 text-blue-900">
                                  <div class="flex-grow-1">
                                    <h5 class="fs-14 mb-1">{{order.customer.fullName}}</h5>
                                    <p class="badge badge-soft-success text-uppercase">{{order.customer.phone}}</p></div>
                                  
                                </div>
                            </td>
                            <td class="border-t-2 border-gray-300 px-3 py-1">
                                <div class="text-sm leading-5 text-blue-900">{{sumProduct(order.details)}}</div>
                            </td>
                            <td class="px-3 py-1 text-left border-t-2 border-gray-300 whitespace-no-wrap">
                                <div class="text-sm leading-5 text-blue-900">{{order.totalPrice}} </div>
                            </td>
                             <td class="border-t-2 border-gray-300 px-3 py-1">
                                <div class="text-sm leading-5 text-blue-900" v-bind:style="{color: order.status.name?order.status.color:'',borderColor: order.status.name?order.status.color:''}">{{order.status.name}}</div>
                            </td>
                            <td class="border-t-2 border-gray-300 px-3 py-1 text-right">
                              <router-link target="_blank" :to="{ path: `/orders/detail/${order._id}`}" class="text-sm leading-5 px-2 rounded-full text-xs text-blue-900 cursor-pointer font-medium"><i class="material-icons mx-2"> remove_red_eye</i></router-link>
                            </td>
                           
                        </tr>
                        </tbody> 
                    </table>
                            
            </div>     
                
            </div>

            <div class="modal-footer px-5 border0-t text-right">
                <button @click="CloseModal('ModalDouble')" class="flex text-white mx-auto max-w-sm rounded text-center bg-gray-500 py-2 px-8 items-center focus:outline-none md:float-right">Annuler</button>
            </div>
          </vue-modal-2>    
        <!-- ___________________________________________________________Debut section PopUp _________________ -->
      </div>
    </div>

    <!-- <div
      v-if="finished && showButtonStart == false"
      class="min-h-screen flex-1 mt-1 bg-gray-100 px-4 pt-3 items-center"
    >
      <div class="bg-white w-full rounded-lg shadow">
        <div class="bg-white w-full rounded-lg shadow">
          <div class="flex justify-center">
            <p></p>
            <p
              class="justify-center font-semibold flex text-blue-500 whitespace-no-wrap"
            >
              <i class="material-icons mx-3">error</i>
              No order To Confirm
            </p>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
var Timer = require("easytimer.js").Timer;
var timer = new Timer();
import Cookies from 'js-cookie'
const _= require('lodash')
export default {
  props: {
     currentUser: { type: Object},
     idWharhouse: { type: Object},
     sous_idWharhouse: { type: String}
   },
  data() {
    return {
      formData: {
        customer: {},
        details: [],
        seller: {},
      },
      zones: [],
      courier: [],
      loading:false,
      loadingeditOrder:false,
      loadinggetorder:false,
      fullPage: false,
      shipping: {
        date: "",
        zone: "",
        courrier: "",
      },
      limit: 1,
      paginate: {
        total: 0,
        currentpage: 1,
        lastpage: 0,
        per_page: 0,
      },
      statusOrder: [],
     // currentUser: {},
      order: [{
        customer: {},
        details: [],
        seller: {},
        teleConsultant: {},
        skippedBy: [],
        unreachedBy: [],
      }],
      showButtonStart: true,
      vShow: false,
      orderFound:false,
      finished: false,
      isEditing: false,
      style: false,
      edit: true,
      sec: 0,
      min: 0,
      hr: 0,
      passedTime: "",
      time:0,
      m: 0,
      s: 0,
      h: 0,
      dateDebut: "",
      zeroH: false,
      zeroM: false,
      zeroS: false,
      motifAnnulation: "",
      nowDate:"",
     // idWharhouse:null,
      motifUnrached:"",
      commentsUnrach:["A rappeler","Boite vocale","Ne répond pas","Hors ligne"],
      products:[],
      searchText: "",
      numberItemRepeated: 0,
      productselected: [],
      checkOutOfstock:{action:false,message:"",type:'normal',stock:0},
      loadingDouble:false,
      dataDouble:[],
      remindDate:null,
      contentRemend:"",
      checkWarehousingParent:[],
       // === UPSELL/CROSS-SELL TRACKING ===
        originalOrder: null,  // Store original order for comparison
        isUpsell: false,
        isCrossSell: false,
        upsellInfo: {
            oldQuantity: 0,
            newQuantity: 0,
            priceDifference: 0,
            commission: 0
        },
        crossSellInfo: {
            bundleName: '',
            totalProducts: 0,
            bundlePrice: 0
        },

         // === UPSELL / CROSS-SELL TRACKING ===
      originalOrderDetails: [],  // Store original details for comparison
      isUpsell: false,
      isCrossSell: false,
      upsellCommission: 0,
      upsellPrice: 0,
      crossSellPrice: 0,
      productUpsellConfig: null,  // Store product's upsell config
      productCrossSellConfig: null,  // Store product's cross-sell config
      // === CROSS-SELL SPECIFIC ===
        matchedCrossSellBundle: null,  // Store the matched bundle
        availableCrossSellBundles: [], // All available bundles for display
        cachedProducts: {},  
    };
  },
  computed: {
        warhouseSelected(){
            return this.$store.getters["wharhouse/warhouseSelected"]({user:_.pick(this.currentUser,['warehouses'])});
        },
    }, 
  watch: { 
    // "$store.state.wharhouse.warhouseSelected": {
    //   async handler(newValue, oldValue) {
    //           await this.getwharhouseId();
    //           await this.getZones();
    //         },
    //         deep: true
    // },
    'idWharhouse': async function(oldVal, newVal) {
            this.idWharhouse=oldVal;  
            await this.getZones();  
            await this.CheckWarehouseParent();
            console.log('idWharhouse change country--------',this.idWharhouse.country)
      }
   },
  async mounted() {
    this.token = this.$jwtService.verifyToken();
    console.log('idWharhouse country--------',this.idWharhouse.country)
    console.log('sous_idWharhouse _id--------',this.sous_idWharhouse)
   // await this.getUser();
   // await this.getwharhouseId();
    await this.getStatus();
    await this.CheckWarehouseParent();
    await this.getZones();
    const nDate = new Date().toLocaleString('en-US', {timeZone: 'Africa/Abidjan'});
    this.nowDate=new Date(nDate);
    // if(this.currentUser.type != "TeleConsultant" && this.currentUser.type != "NRP"){
    //   console.log('nnon telec',this.currentUser.type)
    //       this.$router.push({ name: 'Home' })
    // }
  },
  computed: {
    resultSearchUsers() {
      if (this.searchText) {
        return this.products.filter((product) => {
          var regex = new RegExp(this.searchText, "i");

          return regex.test(product.name);
        });
      } else {
        return this.products;
      }
    },
  },
  methods: {
    // Apply upsell tier when clicked
applyUpsellTier(tier) {
    if (this.order.details.length === 1) {
        // Cancel any active cross-sell first
        if (this.isCrossSell) {
            this.cancelCrossSell();
        }
        
        // Apply upsell
        this.order.details[0].quantity = tier.quantity;
        this.order.details[0].unitPrice = tier.price / tier.quantity;
        this.isUpsell = true;
        this.upsellPrice = tier.price;
        this.upsellCommission = tier.commission || 0;
        
        // Update total price
        this.order.totalPrice = tier.price;
        
        console.log('Upsell applied:', {
            quantity: tier.quantity,
            price: tier.price,
            commission: tier.commission
        });
    }
},
// Cancel cross-sell - Reset to original state
cancelCrossSell() {
    // Reset to original order details
    if (this.originalOrderDetails.length > 0) {
        this.order.details = JSON.parse(JSON.stringify(this.originalOrderDetails));
    }
    
    // Reset cross-sell flags
    this.isCrossSell = false;
    this.crossSellPrice = 0;
    this.matchedCrossSellBundle = null;
    
    // Recalculate normal price
    this.order.totalPrice = this.calculateNormalTotal();
    
    console.log('Cross-sell cancelled, reset to original order');
},

// Calculate normal total (without upsell/cross-sell)
calculateNormalTotal() {
    let total = 0;
    if (this.order && this.order.details) {
        for (const element of this.order.details) {
            total += (element.unitPrice || 0) * (element.quantity || 1);
        }
    }
    return total;
},
// Cancel upsell - Reset to original state
cancelUpsell() {
    if (this.order.details.length === 1 && this.originalOrderDetails.length > 0) {
        // Reset quantity to original
        this.order.details[0].quantity = this.originalOrderDetails[0].quantity;
        
        // Reset upsell flags
        this.isUpsell = false;
        this.upsellPrice = 0;
        this.upsellCommission = 0;
        
        // Recalculate normal price
        this.order.totalPrice = this.calculateNormalTotal();
        
        console.log('Upsell cancelled, reset to original quantity:', this.originalOrderDetails[0].quantity);
    }
},


// Apply cross-sell bundle - CANCELS any upsell
async applyCrossSellBundle(bundle) {
    // Cancel any active upsell first
    if (this.isUpsell) {
        this.cancelUpsell();
    }

    console.log('originalOrderDetails===========',this.originalOrderDetails)
    
    // Remove extra products (keep only original)
    if (this.originalOrderDetails.length > 0) {
        // Keep only original products
        this.order.details = JSON.parse(JSON.stringify(this.originalOrderDetails));
    }

    console.log('bundle===========',bundle)
    console.log('order details===========',this.order.details)
    
    // Add bundle products
    for (const bundleItem of bundle) {
        const bundleProductId = (bundleItem.product && bundleItem.product._id && bundleItem.product._id.toString()) || bundleItem.product.toString();
        console.log('bundleProductId---',bundleProductId)
        
        // Find if product exists in order
        const existingDetailIndex = this.order.details.findIndex(od => {
            const orderProductId = (od.product && od.product._id && od.product._id.toString()) || od.product.toString();
             console.log('orderProductId---',orderProductId)
            return orderProductId === bundleProductId;
        });

        console.log('existingDetailIndex===========',existingDetailIndex)
        
        if (existingDetailIndex === -1) {
            // Product not in order, need to add it
            try {
                const productData = await this.$server.get("products", { id: bundleProductId });
                if (productData && productData.content) {
                    const product = productData.content;
                    
                    // Add to order details
                    this.order.details.push({
                        product: product,
                        quantity: bundleItem.quantity,
                        unitPrice: bundleItem.unitPrice || (product.details[0] && product.details[0].price) || 0
                    });
                    
                    console.log('Added product to order:', product.name);
                }
            } catch (error) {
                console.error('Error adding product:', error);
            }
        } else {
            // Product exists, update quantity
            this.order.details[existingDetailIndex].quantity = bundleItem.quantity;
            this.order.details[existingDetailIndex].unitPrice = bundleItem.unitPrice;
        }
    }
    
    // Set cross-sell active
    this.isCrossSell = true;
    this.crossSellPrice = this.calculateCrossSellPrice(bundle);
    this.matchedCrossSellBundle = bundle;
    
    // Update total price
    this.order.totalPrice = this.crossSellPrice;
    
    console.log('Cross-sell applied:', {
        products: this.order.details.length,
        price: this.crossSellPrice
    });
},

// Get missing products for a bundle
getMissingProducts(bundle) {
    const missing = [];
    
    for (const bundleItem of bundle) {
        const bundleProductId = (bundleItem.product && bundleItem.product._id && bundleItem.product._id.toString()) || bundleItem.product.toString();
        
        const existingDetail = this.order.details.find(od => {
            const orderProductId = (od.product && od.product._id && od.product._id.toString()) || od.product.toString();
            return orderProductId === bundleProductId;
        });
        
        if (!existingDetail) {
            missing.push(this.getProductNameById(bundleItem.product));
        } else if (existingDetail.quantity < bundleItem.quantity) {
            missing.push(`${this.getProductNameById(bundleItem.product)} (need +${bundleItem.quantity - existingDetail.quantity})`);
        }
    }
    
    return missing.length > 0 ? missing.join(', ') : 'Aucun';
},

    isBundleMatched(bundle) {
    return this.matchesCrossSellBundle(bundle);
},

getProductNameById(productId) {
    if (!productId) return 'Unknown';
    
    // Get the ID string
    const id = (productId._id && productId._id.toString()) || productId.toString();
    
    // 1. Check in current order details first
    if (this.order && this.order.details) {
        const orderDetail = this.order.details.find(d => {
            const detailId = (d.product && d.product._id && d.product._id.toString()) || (d.product && d.product.toString());
            return detailId === id;
        });
        
        if (orderDetail && orderDetail.product && orderDetail.product.name) {
            return orderDetail.product.name;
        }
    }
    
    // 2. Check in products list (loaded for add product modal)
    if (this.products && this.products.length > 0) {
        const product = this.products.find(p => {
            const pId = p._id.toString();
            return pId === id;
        });
        if (product && product.name) {
            return product.name;
        }
    }
    
    // 3. Check in cross-sell bundle items themselves (if they have product object)
    if (productId.name) {
        return productId.name;
    }
    
    // 4. Check in cached products
    if (this.cachedProducts && this.cachedProducts[id]) {
        return this.cachedProducts[id];
    }
    
    return 'Produit #' + id.slice(-4); // Show last 4 chars of ID as fallback
},

    // =============================================
// UPSELL / CROSS-SELL DETECTION METHODS
// =============================================

/**
 * Check if current order qualifies as an upsell
 * Upsell = same product, increased quantity
 */
checkForUpsell() {
    if (!this.order || !this.order.details || this.order.details.length !== 1) {
        this.isUpsell = false;
        return;
    }

    const currentDetail = this.order.details[0];
    
    // Check if order has oldDetails (previous state)
    if (this.order.oldDetails && this.order.oldDetails.length > 0) {
        const oldDetail = this.order.oldDetails.find(od => 
            od.product && currentDetail.product && 
            (od.product._id || od.product).toString() === (currentDetail.product._id || currentDetail.product).toString()
        );

        if (oldDetail && currentDetail.quantity > oldDetail.quantity) {
            this.isUpsell = true;
            this.upsellInfo = {
                oldQuantity: oldDetail.quantity,
                newQuantity: currentDetail.quantity,
                quantityAdded: currentDetail.quantity - oldDetail.quantity,
                priceDifference: this.order.totalPrice - (oldDetail.unitPrice * oldDetail.quantity),
                commission: 0 // Will be calculated from product upsells config
            };

            // Get commission from product upsells configuration
            this.getUpsellCommission(currentDetail);
            return;
        }
    }

    // Check if product has upsells configured and current quantity matches
    if (currentDetail.product && currentDetail.product.details) {
        const warehouseDetail = currentDetail.product.details.find(d => 
            d.warehouse && (
                (d.warehouse._id || d.warehouse).toString() === (this.idWharhouse._id || this.idWharhouse).toString()
            )
        );

        if (warehouseDetail && warehouseDetail.upsells && warehouseDetail.upsells.length > 0) {
            const matchingUpsell = warehouseDetail.upsells.find(u => u.quantity === currentDetail.quantity);
            if (matchingUpsell && currentDetail.quantity > 1) {
                // This could be an upsell if quantity > base quantity
                this.checkUpsellFromHistory();
            }
        }
    }
},

/**
 * Get upsell commission from product configuration
 */
async getUpsellCommission(detail) {
    try {
        const product = await this.$server.get("products", { _id: detail.product._id || detail.product });
        if (product && product.content && product.content.details) {
            const warehouseDetail = product.content.details.find(d =>
                d.warehouse && (d.warehouse._id || d.warehouse).toString() === (this.idWharhouse._id).toString()
            );

            if (warehouseDetail && warehouseDetail.upsells) {
                const upsellTier = warehouseDetail.upsells.find(u => u.quantity === detail.quantity);
                if (upsellTier) {
                    this.upsellInfo.commission = upsellTier.commission || 0;
                    this.upsellInfo.upsellPrice = upsellTier.price || 0;
                }
            }
        }
    } catch (error) {
        console.error('Error getting upsell commission:', error);
    }
},

/**
 * Check if current order qualifies as a cross-sell
 * Cross-sell = multiple products matching a bundle configuration
 */
async checkForCrossSell() {
    if (!this.order || !this.order.details || this.order.details.length <= 1) {
        this.isCrossSell = false;
        return;
    }

    try {
        // Get first product to check cross_sells config
        const firstProductId = this.order.details[0].product._id || this.order.details[0].product;
        const product = await this.$server.get("products", { _id: firstProductId });

        if (product && product.content && product.content.details) {
            const warehouseDetail = product.content.details.find(d =>
                d.warehouse && (d.warehouse._id || d.warehouse).toString() === (this.idWharhouse._id).toString()
            );

            if (warehouseDetail && warehouseDetail.cross_sells && warehouseDetail.cross_sells.length > 0) {
                // Check if current order matches any cross-sell bundle
                for (let bundleIndex = 0; bundleIndex < warehouseDetail.cross_sells.length; bundleIndex++) {
                    const bundle = warehouseDetail.cross_sells[bundleIndex];
                    
                    if (this.matchesCrossSellBundle(this.order.details, bundle)) {
                        this.isCrossSell = true;
                        this.crossSellInfo = {
                            bundleName: `Bundle ${bundleIndex + 1}`,
                            totalProducts: bundle.length,
                            bundlePrice: this.calculateBundlePrice(bundle),
                            products: bundle.map(item => ({
                                quantity: item.quantity,
                                unitPrice: item.unitPrice
                            }))
                        };
                        return;
                    }
                }
            }
        }
    } catch (error) {
        console.error('Error checking for cross-sell:', error);
    }

    this.isCrossSell = false;
},

/**
 * Check if order details match a cross-sell bundle
 */
matchesCrossSellBundle(orderDetails, bundle) {
    if (orderDetails.length !== bundle.length) return false;

    for (const bundleItem of bundle) {
        const matchingDetail = orderDetails.find(od => {
            const productId = (od.product._id || od.product).toString();
            const bundleProductId = (bundleItem.product._id || bundleItem.product).toString();
            return productId === bundleProductId && od.quantity === bundleItem.quantity;
        });

        if (!matchingDetail) return false;
    }

    return true;
},

/**
 * Calculate total price from cross-sell bundle
 */
calculateBundlePrice(bundle) {
    return bundle.reduce((total, item) => {
        return total + (item.unitPrice * item.quantity);
    }, 0);
},

/**
 * Apply upsell/cross-sell flags before confirmation
 */
applyUpsellCrossSellFlags(dataToEdit) {
    if (this.isUpsell) {
        dataToEdit.upsel = true;
        dataToEdit.quantity_appseller = this.upsellInfo.quantityAdded || 0;
        
        // Mark in oldDetails
        if (dataToEdit.oldDetails && dataToEdit.oldDetails[0]) {
            dataToEdit.oldDetails[0].is_upsel = true;
        }

        console.log('UPSELL APPLIED:', {
            quantityAdded: dataToEdit.quantity_appseller,
            commission: this.upsellInfo.commission
        });
    }

    if (this.isCrossSell) {
        dataToEdit.cross_sell = true;
        dataToEdit.quantity_cross_sell = this.order.details.reduce((sum, d) => sum + d.quantity, 0);

        // Mark all details as cross-sell
        if (dataToEdit.oldDetails) {
            dataToEdit.oldDetails.forEach(od => {
                od.is_crossSell = true;
            });
        }

        console.log('CROSS-SELL APPLIED:', {
            totalProducts: dataToEdit.quantity_cross_sell,
            bundlePrice: this.crossSellInfo.bundlePrice
        });
    }

    return dataToEdit;
},
    validURL(str) {
    var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
      '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
    return !!pattern.test(str);
  },
    async CloseModal(id){
      this.$vm2.close(id);
      if(id == 'EditOrder'){
        this.loadingeditOrder=true;
        delete this.order.EditOrder;
        const orderCheck=await this.$server.get("orders",{  _id: this.order._id,PopulateProductOnly:true } );
        this.loadingeditOrder=false;
        if(orderCheck.content && orderCheck.content.details) this.order.details=orderCheck.content.details;
      }
    },
    async CheckWarehouseParent(){
      const resW = await this.$server.search("warehouses", { country: this.idWharhouse.country,parent:true,limit:100 }); 
      console.log('resW--------------',resW)
      if(resW.content && resW.content.results){
        this.checkWarehousingParent=resW.content.results;
      }else this.checkWarehousingParent=[];
    },
    sumProduct(data){
      let product="";
      for (let i in data) {
        product+=data[i].product.name
        if(data.length-1 != i) product+=" ,"; 
      }
      return product;
    },
    calculateNormalTotal() {
    let total = 0;
    if (this.order && this.order.details) {
        for (const element of this.order.details) {
            total += element.unitPrice * element.quantity;
        }
    }
    return total;
},
   TotalPrice(){
    let Total = 0;
    
    if(this.order && this.order._id){
        // Calculate normal total
        for (const element of this.order.details) {
            Total += element.unitPrice * element.quantity;
        }
        
        // Check for upsell price
        if (this.isUpsell && this.upsellPrice > 0) {
            this.order.totalPrice = this.upsellPrice;
            return this.upsellPrice;
        }
        
        // Check for cross-sell price
        if (this.isCrossSell && this.crossSellPrice > 0) {
            this.order.totalPrice = this.crossSellPrice;
            return this.crossSellPrice;
        }
        
        // Normal price
        this.order.totalPrice = Total;
    }
    
    return Total;
},
     async checkForCrossSellAfterEdit() {
    // First check upsell (single product quantity increase)
    const isUpsellDetected = this.checkForUpsell();
    
    // If not upsell, check cross-sell (multiple products bundle)
    if (!isUpsellDetected) {
        // Need to reload cross-sell config for all products in order
        await this.loadAllProductsCrossSellConfig();
        
        const isCrossSellDetected = this.checkForCrossSell();
        
        if (isCrossSellDetected) {
            // Show notification to agent
            this.$notify({
                group: 'foo',
                type: 'success',
                title: '🎁 Cross-sell Détecté!',
                text: `Bundle trouvé! Nouveau prix: ${this.crossSellPrice} ${this.idWharhouse.currency}`
            });
            
            // Update order total price
            this.order.totalPrice = this.crossSellPrice;
        }
    }
    
    // Recalculate total price display
    this.TotalPrice();
},

async loadAllProductsCrossSellConfig() {
    // Load cross-sell config from all products in the order
    // Because cross-sell bundles can be defined on any product
    
    this.productCrossSellConfig = [];
    
    for (const detail of this.order.details) {
        const productId = detail.product._id || detail.product;
        
        try {
            const productData = await this.$server.get("products", { 
                id: productId,
            });
            
            if (productData && productData.content) {
                const product = productData.content;
                
                // Find warehouse detail
                const warehouseDetail = product.details.find(d => 
                    d.warehouse && (
                        ((d.warehouse._id && d.warehouse._id.toString()) || d.warehouse.toString()) === this.idWharhouse._id.toString()
                    )
                );
                
                if (warehouseDetail && warehouseDetail.cross_sells && warehouseDetail.cross_sells.length > 0) {
                    // Add bundles from this product (avoid duplicates)
                    for (const bundle of warehouseDetail.cross_sells) {
                        this.productCrossSellConfig.push(bundle);
                    }
                }
            }
        } catch (error) {
            console.error('Error loading cross-sell config for product:', productId, error);
        }
    }
    
    console.log('All cross-sell configs loaded:', this.productCrossSellConfig.length, 'bundles');
},
    async EditOrder(action){
      if(action == 'open') {
        this.$vm2.open('EditOrder');
        this.products=[];
        // === LOAD PRODUCTS FOR NAME RESOLUTION ===
        await this.getProducts();
        
        // === LOAD CROSS-SELL CONFIG ===
        await this.loadUpsellCrossSellConfig();
      }
      if(action == 'products'){
        await this.getProducts({});
        if (this.products.length > 0) {
            this.$vm2.open("ModalProducts");
        } else alert(`There are no products for the selected seller`, "warning");
      }
      if(action == 'addProduct'){
          let fount = 0;
          for (let i = 0; i < this.productselected.length; i++) {
              this.order.details.push(this.productselected[i]);
          }
          this.productselected = [];
          if (this.numberItemRepeated > 0) {
              alert(`There are many products already added!`, "success");
          }
          this.numberItemRepeated = 0;
          this.$vm2.close("ModalProducts");
          
          // === CHECK FOR CROSS-SELL AFTER ADDING PRODUCTS ===
          await this.checkForCrossSellAfterEdit();
      }
      if(action == 'edit'){
        if(this.order.details.length<=0){
          alert(`Cette order ne contient aucun produit !`, "warning");
          return false;
        }else{
          this.loading=true;
          this.order.EditOrder=true;
          const OrderEdi = await this.$server.update("orders", _.pick(this.order, ['_id', 'details','totalPrice','EditOrder']));
          this.loading=false;
          console.log('oooooooooooooooooook 222222222',OrderEdi)
          if(OrderEdi && OrderEdi._id){
            alert(`Order updated`, "success");
            this.$vm2.close("EditOrder");
            delete  this.order.EditOrder;
            // === CHECK FOR UPSELL/CROSS-SELL AFTER EDIT ===
            await this.onOrderEdited();
            // === END ===
          }else  alert(OrderEdi.message_1||OrderEdi, "warning");
        }
      }
    },
    addQuantity(index) {
        this.order.details[index].quantity++;
        
        // === LIVE UPSELL DETECTION ===
        this.checkForUpsell();
        if (this.isUpsell && this.upsellPrice > 0) {
            // Show upsell indicator (optional)
            console.log('Upsell tier matched! New price:', this.upsellPrice);
        }
    },

    removeQuantity(index) {
        if (this.order.details[index].quantity <= 1) {
            // Can't go below 1
        } else {
            this.order.details[index].quantity--;
            
            // === LIVE UPSELL DETECTION ===
            this.checkForUpsell();
        }
    },
    async getProducts() {
      if (this.order.seller && this.order.warehouse) {
        const filters = {
          seller: this.order.seller._id||this.order.seller,
          warehouse:this.order.warehouse._id||this.order.warehouse,
          limit:3000
        };
        const res = await this.$server.search("products", filters);
      
        if (res && res.content) {
          this.products = res.content;
          for (let i in this.products) {
            this.products[i].quantity = this.products[i].details[0].quantity.inStock;
            this.products[i].price = this.products[i].details[0].price;
            this.products[i].seller = this.products[i].seller;
          }
        } else this.products = [];
      }else  alert("You must select a seller", "warning");
    },
    addProductsToTemp(data) {
      if(data.check) {
        const detail = {product: data,unitPrice: data.price,quantity: 1,};
        let found = 0;
        for (let i = 0; i < this.order.details.length; i++) {
          if (this.order.details[i].product._id == data._id) {
            found = found + 1;
            this.numberItemRepeated = this.numberItemRepeated + 1;
          }
        }
        if (found >= 1) {
        } else this.productselected.push(detail);
      }else{
        let pos = this.productselected.map(function (e) {return e.product._id;}).indexOf(data._id);
        this.productselected.splice(pos, 1);
      }
    },
    removeProduct(data, index) {
      if(this.order.details.length==1){
        alert(`Tu peux pas supprimer cette produit please ajouter un autre produit puis essayé !`, "warning");
        return false;
      }
      this.$confirm("Are you sure you want to delete this product?").then(
        async (res) => {
           var index = this.order.details.findIndex(function(o){return o.product._id === data.product._id;})
           if (index !== -1) this.order.details.splice(index, 1);
          data.product.check = false;
          alert(`Product deleted !`, "success");
        }
      );
    },
    exceptDes(text){
      if (text && text.length > 60) text = text.substring(0, 60) + "...";
      return text;
    },
    async getZones() {
        const res = await this.$server.search("zones",{ limit: 10,warehouse:this.idWharhouse._id});
        if (res && res.content.results) this.zones = res.content.results;
        else this.zones = [];
    },
    serchZones: _.debounce(async function(name,type) {
       console.log('event______________',name)
          await this.$store.dispatch('wharhouse/searchUser',{type: 'zone',warhouse:this.idWharhouse._id,search:name}).then((res) => {
            this.zones = res
          })
   }, 500), 
    async getwharhouseId(){
       await this.$store.dispatch('wharhouse/getwharhouseId',{country: this.$store.getters["wharhouse/warhouseSelected"](this.currentUser),}).then((res) => {this.idWharhouse=res;})
    }, 
    async getStatusByName(name) {
        const result = await this.$server.get("status",{  name: name  });
        return result.content;
    },
    dateMin(){ 
      //document.getElementById('shippdate').setAttribute('min', this.$moment(Date.now()).format('yyyy-MM-DD')); 
    },
    CalculateTime() {
      // this.passedTime =this.hr + "hr " + ":" + this.min + " min" + ": " + this.sec + "sec";
      // this.time=this.hr*3600 +  this.min*60 + this.sec;
      // clearTimeout(this.h);
      // clearTimeout(this.m);
      // clearTimeout(this.s);
      this.passedTime=timer.getTimeValues().toString();
    },
    async getUser() {
      const res = await this.$me;
      this.currentUser = res.content;
    },
    async assign(data) {
      //if (!data.teleConsultant) {
        data.teleConsultant = this.currentUser._id;
        data.startDate=this.$moment(new Date()).format('yyyy-MM-DD HH:mm');
        data.updateStartDate=true;
        data.updateTeleConsultant=true;
        await this.$server.update("orders", data);
        delete data.updateTeleConsultant;
      //}
    },
    async SetStatus(){
      if(!Cookies.get('Pending')){
          const s_id1 = await this.getStatusByName("Pending");
          Cookies.set('Pending', JSON.stringify(s_id1), { expires: 30 })
       }
       if(!Cookies.get('Waiting')){
         const s_id2 = await this.getStatusByName("Waiting");
          Cookies.set('Waiting', JSON.stringify(s_id2), { expires: 30 })
       }
       if(!Cookies.get('Unreached')){
         const s_id3 = await this.getStatusByName("Unreached");
          Cookies.set('Unreached', JSON.stringify(s_id3), { expires: 30 })
       }
       if(!Cookies.get('Confirmed')){
         const s_id4 = await this.getStatusByName("Confirmed");
          Cookies.set('Confirmed', JSON.stringify(s_id4), { expires: 30 })
       }
       if(!Cookies.get('Cancelled')){
         const s_id5 = await this.getStatusByName("Cancelled");
          Cookies.set('Cancelled', JSON.stringify(s_id5), { expires: 30 })
       } 
    },
    async getOrderDoubled(phone,seller,product,id){
      this.loadingDouble=true;
      const data = await this.$server.search("orders",{'details.product':product,warehouse:this.idWharhouse._id,phone:phone,_id:id,seller:seller,limit:100});
      this.loadingDouble=false;
      if(data && data.content && data.content.results) this.dataDouble=data.content.results;
      else this.dataDouble=[]
      console.log('data-------',data)
    },
    async RemindOrder(dataToEdit){
      this.loading=true;
      dataToEdit.comment=this.contentRemend;
      if (!this.remindDate) {
        alert('Reminded date required !', "warning");
        this.loading=false;
        return false;
      }
      dataToEdit.oldStatus = dataToEdit.status._id||dataToEdit.status;
      dataToEdit.remind=this.$moment(this.remindDate).format('yyyy-MM-DD HH:mm');
      this.CalculateTime();
      dataToEdit.timeConsumed = this.passedTime;
      dataToEdit.time = parseInt(this.time);
      dataToEdit.dateDebut = this.dateDebut;
      dataToEdit.teleConsultant = null;
      dataToEdit.reminded = true;
      dataToEdit.lastUnreachedDate = null;
      
      
       console.log('date____', dataToEdit);
       //return false
       dataToEdit.idWharhouse = this.idWharhouse;
      const data = await this.$server.update("orders", dataToEdit);
      this.loading=false;
      if (data && data._id) {
        this.refreshData("Order reminded", "success"); 
      }else{
       // await this.$server.update("orders", {_id: this.order._id,teleConsultant:null}); 
        this.showButtonStart = true;
         this.vShow = true;
         this.contentRemend="";
         this.remindDate=null;
         this.order = {
          customer: {},
          details: [],
          seller: {},
          teleConsultant: {},
          skippedBy: [],
          unreachedBy: [],
        };
        alert(data, "warning");
      }
    },
    async startConfirmation() {
      this.checkOutOfstock={action:false,message:"",type:'normal',stock:0};

      await this.getOrder();
      

      if (this.orderFound) {
        await this.assign(this.order);
        timer.reset();
        timer.start();

        timer.addEventListener('secondsUpdated', function (e) {
            $('#gettingValuesExample .hours').html(('0' + timer.getTimeValues().hours).slice(-2));
            $('#gettingValuesExample .minutes').html(('0' + timer.getTimeValues().minutes).slice(-2));
            $('#gettingValuesExample .seconds').html(('0' + timer.getTimeValues().seconds).slice(-2));
        });

         document.body.style.overflow = 'inherit'

        this.showButtonStart = false;
        this.sec = 0;
        this.min = 0;
        this.hr = 0;
        const nDate = new Date().toLocaleString('en-US', {timeZone: 'Africa/Abidjan'});
        let newdate=new Date(nDate)
        this.dateDebut =this.$moment(new Date()).format('yyyy-MM-DD HH:mm');
       // await this.getOrderDoubled(this.order.customer.phone,this.order.seller._id,this.order.details[0].product._id,this.order._id);

       // === SAVE ORIGINAL ORDER DETAILS FOR UPSELL/CROSS-SELL DETECTION ===
        this.originalOrderDetails = JSON.parse(JSON.stringify(this.order.details));
        this.isUpsell = false;
        this.isCrossSell = false;
        this.upsellCommission = 0;
        this.upsellPrice = 0;
        this.crossSellPrice = 0;
        
        // Load upsell/cross-sell config for the product
        await this.loadUpsellCrossSellConfig();
        // === END UPSELL/CROSS-SELL ===
       
      } else {
        alert("No Order To confirm", "warning");
      }
    },
    // =============================================
// UPSELL / CROSS-SELL METHODS
// =============================================

async loadUpsellCrossSellConfig() {
    // Load product upsell/cross-sell configuration
    if (this.order.details && this.order.details.length > 0) {
        const productId = this.order.details[0].product._id || this.order.details[0].product;
        
        try {
            const productData = await this.$server.get("products", { 
                id: productId,
                'details.warehouse': this.idWharhouse._id 
            });
            console.log('productData-----------',productData,productId,this.idWharhouse._id)
            
            if (productData && productData.content) {
                const product = productData.content;

                // Cache current product name
                this.cachedProducts[product._id] = product.name;
                
                // Find warehouse detail
                const warehouseDetail = product.details.find(d => 
                    d.warehouse && (
                        (d.warehouse._id && d.warehouse._id.toString() === this.idWharhouse._id.toString()) ||
                        d.warehouse.toString() === this.idWharhouse._id.toString()
                    )
                );
                
                if (warehouseDetail) {
                    this.productUpsellConfig = warehouseDetail.upsells || [];
                    this.productCrossSellConfig = warehouseDetail.cross_sells || [];
  
                    // Filter: only show bundles with at least 2 products (current + 1 other)
                    this.availableCrossSellBundles = (warehouseDetail.cross_sells || []).filter(bundle => {
                        // Bundle must have at least 2 items
                        if (!bundle || bundle.length < 2) return false;
                        
                        // Must have at least 1 product that is NOT the current product
                        const currentProductId = (this.order.details[0].product._id || this.order.details[0].product).toString();
                        const hasOtherProduct = bundle.some(item => {
                            const itemProductId = (item.product && item.product._id && item.product._id.toString()) || 
                                                (item.product && item.product.toString());
                            return itemProductId !== currentProductId;
                        });
                        
                        // Must have at least 1 other product WITH a valid product selected (not null)
                        const hasValidOtherProduct = bundle.some(item => {
                            const itemProductId = (item.product && item.product._id && item.product._id.toString()) || 
                                                (item.product && item.product.toString());
                            return itemProductId && itemProductId !== currentProductId;
                        });
                        
                        return hasOtherProduct && hasValidOtherProduct;
                    });

                    // === CACHE PRODUCT NAMES FROM CROSS-SELL BUNDLES ===
                    await this.cacheProductNamesFromBundles();
                    
                    console.log('Upsell config loaded:', this.productUpsellConfig);
                    console.log('Cross-sell config loaded:', this.productCrossSellConfig);
                }
            }
        } catch (error) {
            console.error('Error loading upsell/cross-sell config:', error);
        }
    }
},
async cacheProductNamesFromBundles() {
    if (!this.availableCrossSellBundles || this.availableCrossSellBundles.length === 0) return;
    
    // Collect all unique product IDs from bundles
    const productIds = new Set();
    
    for (const bundle of this.availableCrossSellBundles) {
        for (const item of bundle) {
            const id = (item.product && item.product._id && item.product._id.toString()) || item.product.toString();
            if (id && !this.cachedProducts[id]) {
                productIds.add(id);
            }
        }
    }
    
    // Fetch product names for uncached IDs
    for (const id of productIds) {
        try {
            const productData = await this.$server.get("products", { id: id });
            if (productData && productData.content && productData.content.name) {
                this.$set(this.cachedProducts, id, productData.content.name);
            }
        } catch (error) {
            console.error('Error fetching product name for:', id);
        }
    }
    
    console.log('Cached product names:', this.cachedProducts);
},

checkForUpsell() {
    // Upsell = Single product with quantity increase
    if (this.order.details.length === 1 && this.originalOrderDetails.length === 1) {
        const currentDetail = this.order.details[0];
        const originalDetail = this.originalOrderDetails[0];
        
        // Check if same product and quantity increased
        const currentProductId = currentDetail.product._id || currentDetail.product;
        const originalProductId = originalDetail.product._id || originalDetail.product;
        
        if (currentProductId.toString() === originalProductId.toString() && 
            currentDetail.quantity > originalDetail.quantity) {
            
            // Check if we have upsell config for this quantity
            if (this.productUpsellConfig && this.productUpsellConfig.length > 0) {
                const upsellTier = this.productUpsellConfig.find(u => 
                    u.quantity === currentDetail.quantity
                );
                
                if (upsellTier) {
                    this.isUpsell = true;
                    this.upsellPrice = upsellTier.price;
                    this.upsellCommission = upsellTier.commission || 0;
                    
                    console.log('UPSELL DETECTED:', {
                        originalQty: originalDetail.quantity,
                        newQty: currentDetail.quantity,
                        upsellPrice: this.upsellPrice,
                        commission: this.upsellCommission
                    });
                    
                    return true;
                }
            }
        }
    }
    
    this.isUpsell = false;
    this.upsellPrice = 0;
    this.upsellCommission = 0;
    return false;
},

checkForCrossSell() {
    // Reset cross-sell state
    this.isCrossSell = false;
    this.crossSellPrice = 0;
    this.matchedCrossSellBundle = null;
    
    // Cross-sell = Order has products that match a configured bundle
    // Must have more than original products OR different products
    if (!this.productCrossSellConfig || this.productCrossSellConfig.length === 0) {
        console.log('No cross-sell config found');
        return false;
    }
    
    // Check if order details match any cross-sell bundle
    for (const bundle of this.productCrossSellConfig) {
        if (this.matchesCrossSellBundle(bundle)) {
            this.isCrossSell = true;
            this.crossSellPrice = this.calculateCrossSellPrice(bundle);
            this.matchedCrossSellBundle = bundle;
            
            console.log('CROSS-SELL DETECTED:', {
                bundleSize: bundle.length,
                crossSellPrice: this.crossSellPrice,
                bundle: bundle
            });
            
            return true;
        }
    }
    
    console.log('No cross-sell bundle matched');
    return false;
},

matchesCrossSellBundle(bundle) {
    // Bundle structure: [{product: ObjectId, quantity: Number, unitPrice: Number}, ...]
    
    if (!bundle || bundle.length === 0) return false;
    if (!this.order.details || this.order.details.length === 0) return false;
    
    // Order must have same number of different products as bundle
    // (or we can make it flexible - bundle items must ALL be present in order)
    
    console.log('Checking bundle:', bundle);
    console.log('Order details:', this.order.details);
    
    // Check if ALL bundle items are present in the order with correct quantities
    for (const bundleItem of bundle) {
        const bundleProductId = (bundleItem.product && bundleItem.product._id && bundleItem.product._id.toString()) || 
                               (bundleItem.product && bundleItem.product.toString());
        
        if (!bundleProductId) continue;
        
        // Find matching product in order
        const matchingOrderDetail = this.order.details.find(od => {
            const orderProductId = (od.product && od.product._id && od.product._id.toString()) || 
                                   (od.product && od.product.toString());
            return orderProductId === bundleProductId;
        });
        
        if (!matchingOrderDetail) {
            console.log('Bundle item not found in order:', bundleProductId);
            return false;
        }
        
        // Check quantity (order quantity must be >= bundle quantity)
        if (matchingOrderDetail.quantity < bundleItem.quantity) {
            console.log('Quantity mismatch:', {
                bundleQty: bundleItem.quantity,
                orderQty: matchingOrderDetail.quantity
            });
            return false;
        }
    }
    
    // All bundle items found with sufficient quantities
    console.log('Bundle MATCHED!');
    return true;
},

calculateCrossSellPrice(bundle) {
    return bundle.reduce((total, item) => {
        return total + (item.unitPrice * item.quantity);
    }, 0);
},

// Call this when order is edited
async onOrderEdited() {
    // Re-check for upsell/cross-sell after edit
    this.checkForUpsell();
    if (!this.isUpsell) {
        this.checkForCrossSell();
    }
    
    // Update total price if upsell or cross-sell detected
    if (this.isUpsell && this.upsellPrice > 0) {
        this.order.totalPrice = this.upsellPrice;
        console.log('Total price updated to upsell price:', this.upsellPrice);
    } else if (this.isCrossSell && this.crossSellPrice > 0) {
        this.order.totalPrice = this.crossSellPrice;
        console.log('Total price updated to cross-sell price:', this.crossSellPrice);
    }
},

getUpsellQuantityAdded() {
    if (this.isUpsell && this.order.details.length === 1 && this.originalOrderDetails.length === 1) {
        return this.order.details[0].quantity - this.originalOrderDetails[0].quantity;
    }
    return 0;
},

getCrossSellTotalQuantity() {
    if (this.isCrossSell) {
        return this.order.details.reduce((sum, d) => sum + d.quantity, 0);
    }
    return 0;
},
    async getOrder() {
      if(!this.idWharhouse){
         alert("No warehouse found", "warning");
         return false;
      }
      this.loadinggetorder=true;
      console.log('warhouse',this.idWharhouse.country)
      const data = await this.$server.confirmation("orders",{warehouse:this.idWharhouse._id});
      this.loadinggetorder=false;
      console.log('dat____________',data)
      if (data && data.status==200) {
        this.orderFound=true;
        this.order = data.content;
        this.order.date=this.$moment(this.order.date).format('yyyy-MM-DD');
      } else {
        this.order=[{
          customer: {},
          details: [],
          seller: {},
          teleConsultant: {},
          skippedBy: [],
          unreachedBy: [],
      }],
        this.orderFound=false;
        this.finished = true;
      }
    },
    //****************************** Zones  ***********************************/
    async getCourierZone(zone) {
      console.log('zone____',zone)
      if(zone){
        const filter = {
          type: "Courier",
          zones: zone._id,
          limit:1000
        };
        const res = await this.$server.search("users", filter);
        console.log("HII JE SUIS res soukaina", res);
        if (res && res.content.results) {
          this.courier = res.content.results;
        } else this.courier = [];
      }
    },
    // **************************************************************************
    async getStatus() {
      const res = await this.$server.search("status");
      if (res && res.content.results) this.statusOrder = res.content.results;
      else this.statusOrder = [];
    },
    getStatusId(status) {
      for (let i in this.statusOrder) {
        if (this.statusOrder[i].name == status) {
          return this.statusOrder[i]._id;
        }
      }
    },

    CreateShipping() {
      const data = {
        address: this.order.customer.shippingAddress,
        date: this.shipping.date,
        order: this.order._id,
        zone: this.shipping.zone._id,
        courrier: this.shipping.courrier._id,
      };
      console.log("HIIIIIIIIIIIIIIII SE SUIS data", data);
      // const data = await this.$server.create("status", this.formData);
    },

    async ConfirmOrderStatus(dataToEdit) {
     this.loading=true;
    // console.time('ConfirmOrderStatus');
    // await this.SetStatus();

      this.dateMin();
      this.CalculateTime();
      dataToEdit.timeConsumed = this.passedTime;
      dataToEdit.time = parseInt(this.time);
      dataToEdit.dateDebut = this.dateDebut;
      dataToEdit.teleConsultantConfirm = this.currentUser;
     
     //console.log('warhouse________________',this.order)
      if (
        this.shipping.date &&
        this.order.customer.shippingAddress &&
        this.order.warehouse &&
        this.order._id
      ) {
         const datashipping = {
          address: this.order.customer.shippingAddress,
          date: this.$moment(this.shipping.date).format('yyyy-MM-DD'),
         // order: this.order._id,
         // seller: this.order.seller,
         // warehouse: this.order.warehouse,
          status: "queued",
      };
      if(this.shipping.courrier){
        datashipping.courier=this.shipping.courrier;
      }
      if(this.shipping.zone){
        datashipping.zone=this.shipping.zone;
        dataToEdit.zone=this.shipping.zone;
      }

      if(this.checkWarehousingParent.length>0 && !this.shipping.warehouseParent){
        this.loading=false;
        alert("Zone (City) required !", "warning");
        return false;
      }else{
        if(this.checkWarehousingParent.length === 0 && this.idWharhouse.country == 'CI' && !this.shipping.zone){
          this.loading=false;
          alert("Zone required !", "warning");
          return false;
        }
      }

     

        dataToEdit.shipping = datashipping;
        console.log('dataToEdit 1111111',dataToEdit.shipping)
        //console.log('oooooooooooooooooook 1111111')
        delete dataToEdit.seller;
       // === UPSELL / CROSS-SELL DETECTION & FLAGS ===
      // Check for upsell/cross-sell before confirmation
      this.checkForUpsell();
      if (!this.isUpsell) {
          this.checkForCrossSell();
      }

      // Apply upsell data
      if (this.isUpsell) {
          dataToEdit.upsel = true;
          dataToEdit.quantity_appseller = this.getUpsellQuantityAdded();
          
          // Apply upsell price
          if (this.upsellPrice > 0) {
              dataToEdit.totalPrice = this.upsellPrice;
          }
          
          // Store original details for tracking
          dataToEdit.oldDetails = this.originalOrderDetails.map(od => ({
              product: od.product._id || od.product,
              quantity: od.quantity,
              unitPrice: od.unitPrice,
              is_upsel: true
          }));
          
          // Add commission to affiliate if exists
          if (dataToEdit.affiliate && this.upsellCommission > 0) {
              dataToEdit.affiliate.upsellCommission = this.upsellCommission;
          }
          
          console.log('CONFIRMING WITH UPSELL:', {
              upsel: true,
              quantity_appseller: dataToEdit.quantity_appseller,
              upsellPrice: dataToEdit.totalPrice,
              commission: this.upsellCommission
          });
      }

      // Apply cross-sell data
      if (this.isCrossSell) {
          dataToEdit.cross_sell = true;
          dataToEdit.quantity_cross_sell = this.getCrossSellTotalQuantity();
          
          // Apply cross-sell price
          if (this.crossSellPrice > 0) {
              dataToEdit.totalPrice = this.crossSellPrice;
          }
          
          // Mark all details as cross-sell
          dataToEdit.oldDetails = this.originalOrderDetails.map(od => ({
              product: od.product._id || od.product,
              quantity: od.quantity,
              unitPrice: od.unitPrice,
              is_crossSell: true
          }));
          
          console.log('CONFIRMING WITH CROSS-SELL:', {
              cross_sell: true,
              quantity_cross_sell: dataToEdit.quantity_cross_sell,
              crossSellPrice: dataToEdit.totalPrice
          });
      }
      // === END UPSELL / CROSS-SELL ===

      dataToEdit.Confirmation=true;

        dataToEdit.country=this.idWharhouse.country;
        dataToEdit.countryName=this.idWharhouse.name;

        if(this.shipping.warehouseParent){
          for (let index = 0; index < dataToEdit.details.length; index++) {
                const expLineOrder = dataToEdit.details[index];
                expLineOrder.warehouseParent = this.shipping.warehouseParent;
                expLineOrder.warehouseParentName = this.shipping.warehouseParent.name;
            }
        }
        let dataOrr = await this.$server.update("orders", dataToEdit);
        //console.timeEnd('ConfirmOrderStatus');
        this.loading=false;
         console.log('oooooooooooooooooook 222222222',dataOrr)
        if(dataOrr && dataOrr._id){
          alert("Order Confirmed", "success");
          this.order = {
            customer: {},
            details: [],
            seller: {},
            teleConsultant: {},
            skippedBy: [],
          };
          this.shipping={}
          this.showButtonStart = true;
          this.vShow = true;
        }else {
           let BodyDataOrder={_id: this.order._id,teleConsultant:null};
           if(dataOrr.message_1 && dataOrr.action && dataOrr.action=='Confirmation'){
              BodyDataOrder.warehouse=dataOrr.warehouse;
              BodyDataOrder.productId=dataOrr.productId;
              BodyDataOrder.ChangeToWaiting=true;
              BodyDataOrder.quantity=dataOrr.quantity;
              await this.$server.update("orders", BodyDataOrder); 
           } 
           
            this.showButtonStart = true;
            this.vShow = true;
            this.order = {
              customer: {},
              details: [],
              seller: {},
              teleConsultant: {},
              skippedBy: [],
            };
            this.shipping={};
            console.log('dataOrr -----------------',dataOrr)
            alert(dataOrr.message_1||dataOrr, "warning");
          }
      } else {
        this.loading=false;
        alert("You must fill all required field", "warning");
      }
    },
    async OrangeOrderStatus(dataToEdit,name) {

      this.$confirm(`Etes-vous sûr de changer la commande en: ${name} ?`).then(async (res) => {
         if (res) {
           this.loading=true;
           let id = await this.getStatusByName(name);
           dataToEdit.status = id;
           dataToEdit.statusCallcenter = id;
           this.CalculateTime();
           dataToEdit.timeConsumed = this.passedTime;
           dataToEdit.time = parseInt(this.time);
           dataToEdit.dateDebut = this.dateDebut;
          // dataToEdit.teleConsultantConfirm = this.currentUser._id;
           dataToEdit[name.replace(/\s/g, '')] = true;
           dataToEdit.comment='';
           const data = await this.$server.update("orders", dataToEdit);
           this.loading=false;
           if (data && data._id) {
              this.refreshData('Order updated', "success")
           }else{
           // await this.$server.update("orders", {_id: this.order._id,teleConsultant:null}); 
              alert(data,"warning");
               this.motifUnrached="";
              this.motifAnnulation="";
              this.showButtonStart = true;
              this.vShow = true;
                this.order = {
                  customer: {},
                  details: [],
                  seller: {},
                  teleConsultant: {},
                  skippedBy: [],
                  unreachedBy: [],
                };
                this.shipping={}
            }

          }
       });
      
   },
    async skipOrder(dataToEdit) {

      if(this.checkOutOfstock.action){
         this.loading=false;
        // const dataOr = await this.$server.update("orders", {_id: this.order._id,teleConsultant:null}); 
         this.showButtonStart = true;
         this.vShow = true;
          this.order = {
            customer: {},
            details: [],
            seller: {},
            teleConsultant: {},
            skippedBy: [],
          };
          this.shipping={}
         return false;
      }

      // let id =  await this.getStatusByName("Skipped");
      // const element = {
      //   user: this.currentUser._id,
      // };

      // dataToEdit.skippedBy.push(element);
      // dataToEdit.skiped = id;
      // dataToEdit.teleConsultant = null;

      // this.$confirm("You want to skip this order?").then(async (res) => {
      //   if (res) {
      //     this.CalculateTime();
      //     dataToEdit.timeConsumed = this.passedTime;
      //     dataToEdit.time = parseInt(this.time);
      //      dataToEdit.teleConsultantConfirm = this.currentUser;
      //     dataToEdit.dateDebut = this.dateDebut;
         
      //     const data = await this.$server.update("orders", dataToEdit);
      //     if (data._id) {
      //       alert("Order skipped", "warning");
      //       this.order = {
      //         customer: {},
      //         details: [],
      //         seller: {},
      //         teleConsultant: {},
      //         skippedBy: [],
      //         unreachedBy: [],
      //       };
      //       this.showButtonStart = true;
      //       this.vShow = true;
      //     }
      //   }
      // });
    },
    /************************************************* */
    async cancelOrder(dataToEdit) {
      if(this.motifAnnulation) this.motifAnnulation=this.motifAnnulation.toString().trim();
      if(!this.motifAnnulation){
          alert('Reason for cancellation required', "warning");
          return false
      }
      this.loading=true;
      dataToEdit.motifAnnulation = this.motifAnnulation;
      this.CalculateTime();
      dataToEdit.timeConsumed = this.passedTime;
      dataToEdit.time = parseInt(this.time);
      dataToEdit.teleConsultantConfirm = this.currentUser;
      dataToEdit.dateDebut = this.dateDebut;

      dataToEdit.comment=this.motifAnnulation;

      dataToEdit.cancelOrder=true;
      const data = await this.$server.update("orders", dataToEdit);
      //console.timeEnd('cancelOrder');
      this.loading=false;
      if (data && data._id) {
        this.showButtonStart = true;
        this.vShow = true;
        this.motifAnnulation="";
        alert("Order cancelled", "success");
        this.order = {
          customer: {},
          details: [],
          seller: {},
          teleConsultant: {},
          skippedBy: [],
          unreachedBy: [],
        };
      }else{
       // await this.$server.update("orders", {_id: this.order._id,teleConsultant:null}); 
         this.showButtonStart = true;
         this.vShow = true;
         this.motifAnnulation="";
         this.order = {
          customer: {},
          details: [],
          seller: {},
          teleConsultant: {},
          skippedBy: [],
          unreachedBy: [],
        };
        alert(data, "error");
      }
    },

    /************************************************************/

    async UnreachedOrder(dataToEdit) {
      this.loading=true;
      //console.time('UnreachedOrder');
      const nDate = new Date().toLocaleString('en-US', {timeZone: 'Africa/Abidjan'});
      let newdate=new Date(nDate);
      dataToEdit.oldStatus = dataToEdit.status._id||dataToEdit.status;
        
      dataToEdit.teleConsultant = null;
      dataToEdit.lastUnreachedDate = newdate;
    
      this.CalculateTime();
      dataToEdit.timeConsumed = this.passedTime;
      dataToEdit.time = parseInt(this.time);
      dataToEdit.dateDebut = this.dateDebut;
      dataToEdit.dateUnrash = newdate;
      dataToEdit.comment=this.motifUnrached;
      if(dataToEdit.remind){
        dataToEdit.remind=null;
        dataToEdit.isReminded=false;
      }
      
      
      delete dataToEdit.updateStartDate;

          //check order teleconsulatnt
          const orderCheck = await this.$server.get("orders",{  _id: this.order._id,PopulateProductOnly:true } );
          if(!this.motifUnrached){
             alert('Reason unreached required', "warning");
             this.loading=false;
             return false
          }
          const element = {
            user: this.currentUser._id,
            date: orderCheck.content.startDate
          };
          dataToEdit.unreachedBy.push(element);
          dataToEdit.pending_unrached = true;
          dataToEdit.lastUnreachedDate = orderCheck.content.startDate;

          console.log('ooook unrached')
          const data = await this.$server.update("orders", dataToEdit);
          console.timeEnd('UnreachedOrder');
          this.loading=false;
          if (data && data._id) {
              this.refreshData("Order unreached", "success"); 
          }else{
           // await this.$server.update("orders", {_id: this.order._id,teleConsultant:null}); 
            alert(data,"warning");
            this.motifUnrached="";
            this.motifAnnulation="";
              this.showButtonStart = true;
              this.vShow = true;
                this.order = {
                  customer: {},
                  details: [],
                  seller: {},
                  teleConsultant: {},
                  skippedBy: [],
                  unreachedBy: [],
                };
                this.shipping={}
            }
      //   }
      // });
    },
    /****************** Edit Information **********************/
    activateInEditMode() {
      this.isEditing = true;
      this.edit = false;
      this.style = true;
    },
    refreshData(message,type){
       alert(message,type);
       this.motifUnrached="";
       this.motifAnnulation="";
       this.remindDate=null;
       this.contentRemend="";
        this.showButtonStart = true;
         this.vShow = true;
          this.order = {
            customer: {},
            details: [],
            seller: {},
            teleConsultant: {},
            skippedBy: [],
            unreachedBy: [],
          };
          this.shipping={}
    },
    async updateData(dataToEdit) {
      this.$confirm("You want really to update information ?").then(
        async (res) => {
          if (res) {
            const data = await this.$server.update("orders", dataToEdit);
            if (data._id) {
              this.isEditing = false;
              this.style = false;
              this.edit = true;
              alert("updated", "success");
            }
          }
        }
      );
    },
    async desactivateInResetMode() {
      this.isEditing = false;
      this.style = false;
      this.edit = true;
      await this.getOrder();
    },

    ChronoStart() {
      // if (this.sec < 60) {
      //   this.s = setTimeout(() => {
      //     this.sec += 1;
      //     this.ChronoStart();
      //   }, 1000);
      //   this.remettreAZero();
      // } else if (this.min == 60) {
      //   this.hr += 1;
      //   this.min = 0;
      //   this.h = setTimeout(() => {
      //     this.sec += 1;
      //     this.ChronoStart();
      //   }, 1000);
      //   this.remettreAZero();
      // } else {
      //   this.min += 1;
      //   this.sec = 0;
      //   this.m = setTimeout(() => {
      //     this.sec += 1;
      //     this.ChronoStart();
      //   }, 1000);
      //   this.remettreAZero();
      // }

      if (this.min==0) {this.min='00'}
      if(this.hr==0) {this.hr='00'}
      this.sec++;
      if (this.sec<10){this.sec='0'+this.sec;}
      if (this.hr==24){this.hr='0'+0;}
      if (this.sec==60){this.sec=0; this.min++;if(this.min<10){this.min='0'+this.min;}}
      if (this.min==60){this.min='0'+0;this.hr++;if(this.hr<10){this.hr='0'+this.hr;}}
     setTimeout(() => this.ChronoStart() , 1000);
    },

    remettreAZero() {
      if (this.sec < 10) {
        this.zeroS = true;
      } else {
        this.zeroS = false;
      }
      if (this.min < 10) {
        this.zeroM = true;
      } else {
        this.zeroM = false;
      }
      if (this.hr < 10) {
        this.zeroH = true;
      } else {
        this.zeroH = false;
      }
    },
  },
};
</script>


<style scoped>
/* Upsell & Cross-sell Cards */
.offers-section {
    margin-bottom: 1rem;
}

.upsell-card, .crosssell-card {
    border-radius: 0.5rem;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.upsell-tier-card {
    min-width: 150px;
}

.bundle-card {
    transition: all 0.2s ease;
}

.bundle-card:hover {
    transform: translateY(-2px);
}

/* Animation for matched bundle */
@keyframes pulse-green {
    0%, 100% { box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.4); }
    50% { box-shadow: 0 0 0 10px rgba(34, 197, 94, 0); }
}

.bundle-card.border-green-500 {
    animation: pulse-green 2s infinite;
}

/* Gradient backgrounds */
.bg-gradient-to-r {
    background: linear-gradient(to right, var(--tw-gradient-from), var(--tw-gradient-to));
}

.from-purple-600 { --tw-gradient-from: #9333ea; }
.to-purple-400 { --tw-gradient-to: #c084fc; }
.from-blue-600 { --tw-gradient-from: #2563eb; }
.to-blue-400 { --tw-gradient-to: #60a5fa; }

.bg-depot{
  background-color: #df24cb;
}
.btn-action {
    -webkit-animation: shadow-pulse 1s infinite;
    animation: shadow-pulse 1s infinite;
}
@keyframes shadow-pulse{ 
    0%{box-shadow:0 0 0 0px rgba(30, 112, 185);}
    100%{box-shadow:0 0 0 15px rgba(0, 0, 0, 0);}
}
.mx-datepicker{
  width: 100%;
  padding: 6px 8px;
}
/* ===== Confirmation Main Page ===== */
.conf-main-page {
  min-height: 100vh;
  background: #f0f2f5;
  padding-top: 60px;
  position: relative;
}
.conf-africa-dots {
  position: fixed;
  top: 50%;
  right: 30px;
  transform: translateY(-50%);
  width: 380px;
  height: 460px;
  pointer-events: none;
  z-index: 0;
  opacity: 0.06;
  fill: #4285f4;
}
@media (max-width: 900px) {
  .conf-africa-dots { display: none; }
}
.conf-timer-wrap {
  padding: 20px 16px 8px;
  display: flex;
  justify-content: center;
}
.conf-body {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 16px 32px;
}

/* Detail Cards Grid */
.conf-detail-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
  margin-bottom: 20px;
}
@media (max-width: 900px) {
  .conf-detail-grid { grid-template-columns: repeat(2, 1fr); }
}
@media (max-width: 500px) {
  .conf-detail-grid { grid-template-columns: 1fr; }
}
.conf-detail-card {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 18px 20px;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
  transition: all 0.2s ease;
}
.conf-detail-card:hover {
  box-shadow: 0 4px 15px rgba(0,0,0,0.08);
  transform: translateY(-2px);
}
.conf-detail-icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.conf-detail-icon i { font-size: 22px; color: #fff; }
.conf-detail-icon-blue { background: linear-gradient(135deg, #4285f4, #5a9cf6); }
.conf-detail-icon-green { background: linear-gradient(135deg, #34a853, #4cba6a); }
.conf-detail-icon-purple { background: linear-gradient(135deg, #7c3aed, #9f67ff); }
.conf-detail-icon-orange { background: linear-gradient(135deg, #f59e0b, #fbbf24); }
.conf-detail-label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.conf-detail-value {
  display: block;
  font-size: 14px;
  font-weight: 700;
  color: #1a1a2e;
  margin-top: 2px;
  word-break: break-all;
}

/* Two Column Layout */
.conf-two-col {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}
.conf-col-left {
  flex: 3;
  min-width: 0;
  display: flex;
  flex-direction: column;
}
.conf-col-right {
  flex: 2;
  min-width: 0;
}
@media (max-width: 900px) {
  .conf-two-col { flex-direction: column; }
}

/* Card */
.conf-card {
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
  overflow: hidden;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}
.conf-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #f3f4f6;
}
.conf-card-title {
  font-size: 16px;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0;
}

/* Out of Stock Alert */
.conf-alert-stock {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px 18px;
  background: #fef3c7;
  border: 1px solid #fde68a;
  border-radius: 12px;
  margin-bottom: 20px;
  color: #92400e;
  font-size: 14px;
}
.conf-alert-stock svg { flex-shrink: 0; margin-top: 2px; }
.conf-alert-stock-info {
  display: block;
  font-size: 12px;
  color: #a16207;
  margin-top: 4px;
}

/* Action Buttons */
.conf-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 20px 24px;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
  margin-bottom: 24px;
  justify-content: center;
}
.conf-action-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 12px 22px;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}
.conf-action-btn:hover {
  transform: translateY(-2px);
  filter: brightness(1.1);
}
.conf-action-btn:active {
  transform: translateY(0);
}
.conf-action-btn i { font-size: 18px; }
.conf-action-confirm { background: #34a853; box-shadow: 0 3px 10px rgba(52,168,83,0.3); }
.conf-action-unreached { background: #4285f4; box-shadow: 0 3px 10px rgba(66,133,244,0.3); }
.conf-action-remind { background: #f59e0b; box-shadow: 0 3px 10px rgba(245,158,11,0.3); }
.conf-action-depot { background: #8b5cf6; box-shadow: 0 3px 10px rgba(139,92,246,0.3); }
.conf-action-cancel { background: #ef4444; box-shadow: 0 3px 10px rgba(239,68,68,0.3); }
.conf-action-skip { background: #f97316; box-shadow: 0 3px 10px rgba(249,115,22,0.3); }

@media (max-width: 640px) {
  .conf-actions { gap: 8px; }
  .conf-action-btn { flex: 1 1 calc(50% - 8px); justify-content: center; padding: 10px 12px; font-size: 13px; }
}

/* ===== Products Section ===== */
.conf-products-list {
  padding: 8px 20px;
}
.conf-product-row {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 0;
  border-bottom: 1px solid #f3f4f6;
}
.conf-product-row:last-child {
  border-bottom: none;
}
.conf-product-img {
  width: 48px;
  height: 48px;
  border-radius: 10px;
  object-fit: cover;
  border: 1.5px solid #e5e7eb;
  flex-shrink: 0;
}
.conf-product-info {
  flex: 1;
  min-width: 0;
}
.conf-product-name {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #1a1a2e;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.conf-product-sub {
  display: block;
  font-size: 12px;
  color: #9ca3af;
  margin-top: 2px;
}
.conf-product-price {
  font-size: 15px;
  font-weight: 700;
  color: #1a1a2e;
  white-space: nowrap;
  flex-shrink: 0;
}
.conf-product-price sup {
  font-size: 10px;
  color: #6b7280;
}
.conf-product-link {
  flex-shrink: 0;
}
.conf-product-link-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 8px;
}
.conf-product-link-active {
  background: rgba(66, 133, 244, 0.1);
  color: #4285f4;
  transition: all 0.2s ease;
  text-decoration: none;
}
.conf-product-link-active:hover {
  background: #4285f4;
  color: #fff;
}
.conf-product-link-active i { font-size: 18px; }
.conf-product-link-none {
  background: #f3f4f6;
  color: #9ca3af;
  font-size: 11px;
  font-weight: 600;
}

/* Sell Indicators */
.conf-sell-indicator {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 20px 12px;
  padding: 14px 16px;
  border-radius: 10px;
  gap: 12px;
}
.conf-sell-cross {
  background: #eff6ff;
  border: 1px solid #bfdbfe;
}
.conf-sell-upsell {
  background: #faf5ff;
  border: 1px solid #e9d5ff;
}
.conf-sell-indicator-left {
  display: flex;
  align-items: center;
  gap: 10px;
}
.conf-sell-indicator-icon {
  font-size: 22px;
}
.conf-sell-indicator-title {
  display: block;
  font-size: 13px;
  font-weight: 700;
  color: #1a1a2e;
}
.conf-sell-indicator-sub {
  display: block;
  font-size: 12px;
  color: #6b7280;
}
.conf-sell-indicator-right {
  text-align: right;
}
.conf-sell-indicator-old {
  display: block;
  font-size: 12px;
  color: #9ca3af;
  text-decoration: line-through;
}
.conf-sell-indicator-new {
  display: block;
  font-size: 16px;
  font-weight: 700;
  color: #1a1a2e;
}
.conf-sell-indicator-commission {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #34a853;
}

/* Total Bar */
.conf-total-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: #f9fafb;
  border-top: 1px solid #f3f4f6;
  border-radius: 0 0 14px 14px;
}
.conf-total-label {
  font-size: 14px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.conf-total-right {
  display: flex;
  align-items: center;
  gap: 10px;
}
.conf-total-old {
  font-size: 13px;
  color: #9ca3af;
  text-decoration: line-through;
}
.conf-total-value {
  font-size: 20px;
  font-weight: 800;
  color: #34a853;
}
.conf-total-upsell { color: #7c3aed; }
.conf-total-cross { color: #4285f4; }
.conf-total-value sup {
  font-size: 11px;
  font-weight: 600;
}
.conf-total-badge {
  font-size: 10px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 6px;
  letter-spacing: 0.06em;
}
.conf-total-badge-purple {
  background: #f3e8ff;
  color: #7c3aed;
}
.conf-total-badge-blue {
  background: #dbeafe;
  color: #4285f4;
}

/* ===== Customer Section ===== */
.conf-customer-body {
  padding: 20px;
}
.conf-customer-phone-card {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 18px;
  background: linear-gradient(135deg, #eef6ff, #e8f0fe);
  border: 1.5px solid #c8ddfb;
  border-radius: 12px;
  margin-bottom: 20px;
}
.conf-customer-phone-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: linear-gradient(135deg, #4285f4, #5a9cf6);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.conf-customer-phone-icon i {
  font-size: 22px;
  color: #fff;
}
.conf-customer-phone-info {
  display: flex;
  flex-direction: column;
}
.conf-customer-phone-label {
  font-size: 11px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.conf-customer-phone-value {
  font-size: 18px;
  font-weight: 700;
  color: #1a1a2e;
  letter-spacing: 0.03em;
}
.conf-customer-fields {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.conf-customer-field-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  margin-bottom: 6px;
}
.conf-customer-field-input {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  background: #f9fafb;
  border: 1.5px solid #e5e7eb;
  border-radius: 10px;
  padding: 10px 14px;
  transition: all 0.2s ease;
}
.conf-customer-field-input:focus-within {
  border-color: #4285f4;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(66, 133, 244, 0.1);
}
.conf-customer-field-icon {
  font-size: 20px;
  color: #9ca3af;
  margin-top: 1px;
  flex-shrink: 0;
}
.conf-customer-field-input input,
.conf-customer-field-input textarea {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-size: 14px;
  color: #1f2937;
  resize: none;
  font-family: inherit;
}
.conf-customer-field-input input:disabled,
.conf-customer-field-input textarea:disabled {
  color: #1f2937;
  -webkit-text-fill-color: #1f2937;
  opacity: 1;
}

/* ===== Confirmation Start Page ===== */
.conf-start-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f8faff 0%, #eef2ff 50%, #e8f0fe 100%);
  position: relative;
  overflow: hidden;
  padding: 40px 20px;
  margin-top: -16px;
}
.conf-start-bg-shape {
  position: absolute;
  border-radius: 50%;
  opacity: 0.06;
}
.conf-start-bg-shape-1 {
  width: 500px;
  height: 500px;
  background: #4285f4;
  top: -150px;
  right: -100px;
  animation: confFloat 8s ease-in-out infinite;
}
.conf-start-bg-shape-2 {
  width: 350px;
  height: 350px;
  background: #4285f4;
  bottom: -80px;
  left: -100px;
  animation: confFloat 10s ease-in-out infinite reverse;
}
.conf-start-bg-shape-3 {
  width: 200px;
  height: 200px;
  background: #7aaffc;
  top: 40%;
  left: 15%;
  animation: confFloat 12s ease-in-out infinite;
}
@keyframes confFloat {
  0%, 100% { transform: translate(0, 0); }
  33% { transform: translate(12px, -18px); }
  66% { transform: translate(-8px, 12px); }
}
.conf-start-content {
  position: relative;
  z-index: 1;
  text-align: center;
  max-width: 480px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.conf-start-img-wrap {
  margin-bottom: 32px;
  animation: confImgFloat 4s ease-in-out infinite;
}
.conf-start-img {
  width: 320px;
  max-width: 80vw;
  height: auto;
  filter: drop-shadow(0 20px 40px rgba(66, 133, 244, 0.18));
  transition: transform 0.4s ease;
}
.conf-start-img:hover {
  transform: scale(1.03);
}
@keyframes confImgFloat {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-12px); }
}
.conf-start-title {
  font-size: 2rem;
  font-weight: 800;
  color: #1a1a2e;
  margin: 0 0 12px;
  letter-spacing: -0.02em;
}
.conf-start-desc {
  font-size: 15px;
  color: #6b7280;
  line-height: 1.7;
  margin: 0 0 28px;
}
.conf-start-badges {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 36px;
  flex-wrap: wrap;
}
.conf-start-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
}
.conf-start-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-width: 220px;
  padding: 16px 40px;
  font-size: 18px;
  font-weight: 700;
  color: #fff;
  background: linear-gradient(135deg, #4285f4 0%, #5a9cf6 100%);
  border: none;
  border-radius: 60px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 8px 25px rgba(66, 133, 244, 0.35);
  text-transform: uppercase;
  letter-spacing: 0.08em;
  position: relative;
  animation: confBtnPulse 2s ease-in-out infinite;
}
@keyframes confBtnPulse {
  0%, 100% { box-shadow: 0 8px 25px rgba(66, 133, 244, 0.35); }
  50% { box-shadow: 0 8px 40px rgba(66, 133, 244, 0.55), 0 0 0 8px rgba(66, 133, 244, 0.08); }
}
.conf-start-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 35px rgba(66, 133, 244, 0.5);
  background: linear-gradient(135deg, #3367d6 0%, #4285f4 100%);
  animation: none;
}
.conf-start-btn:active {
  transform: translateY(-1px);
}
.conf-start-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
  animation: none;
}
.conf-start-btn-text {
  position: relative;
  z-index: 1;
}
.conf-start-btn-arrow {
  transition: transform 0.3s ease;
  animation: confArrowBounce 1.5s ease-in-out infinite;
}
@keyframes confArrowBounce {
  0%, 100% { transform: translateX(0); }
  50% { transform: translateX(5px); }
}
.conf-start-btn:hover .conf-start-btn-arrow {
  animation: none;
  transform: translateX(6px);
}

.wrap-1{
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
/* Pulse animation for badges */
@keyframes pulse {
    0%, 100% {
        opacity: 1;
    }
    50% {
        opacity: 0.5;
    }
}

.animate-pulse {
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

/* Ping animation for notification dot */
@keyframes ping {
    75%, 100% {
        transform: scale(2);
        opacity: 0;
    }
}

.animate-ping {
    animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
}
.button-2 {
  min-width: 300px;
min-height: 60px;
font-family: 'Nunito', sans-serif;
font-size: 22px;
text-transform: uppercase;
letter-spacing: 1.3px;
font-weight: 700;
background: linear-gradient(90deg, rgb(113, 159, 236) 0%, rgb(66, 133, 244) 100%);
border: none;
border-radius: 1000px;
box-shadow: 12px 12px 24px rgba(103, 157, 247, 0.53);
transition: all 0.3s ease-in-out 0s;
cursor: pointer;
outline: none;
position: relative;
padding: 10px;
color: #fff;
  }

 .button-2::before {
  content: '';
  border-radius: 1000px;
  min-width: calc(300px + 12px);
  min-height: calc(60px + 12px);
  border: 6px solid #00FFCB;
  box-shadow: 0 0 60px rgba(0,255,203,.64);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  transition: all .3s ease-in-out 0s;
}

.button-2:hover, .button-2:focus {
  color: #fff;
  transform: translateY(-6px);
}

.button-2:hover::before, .button-2:focus::before {
  opacity: 1;
}

.button-2::after {
  content: '';
  width: 30px; height: 30px;
  border-radius: 100%;
  border: 6px solid #00FFCB;
  position: absolute;
  z-index: -1;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: ring 1.5s infinite;
}

.button-2:hover::after, .button-2:focus::after {
  animation: none;
  display: none;
}

@keyframes ring {
  0% {
    width: 30px;
    height: 30px;
    opacity: 1;
  }
  100% {
    width: 300px;
    height: 300px;
    opacity: 0;
  }
}

.bg-imgg:before{
  content: ' ';
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  opacity: 0.2;
  background: url("https://storeno.b-cdn.net/shipsen/11-2022/1669062344861.jpeg") no-repeat center center;
  background-size: auto;
  background-size: cover;
}
.phone{
  background-color: #e8bc52;
  border-color: #e8bc52;
  color: #fff !important;
  display: inline-block;
  font-weight: 500;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  padding: 2px;
}
.box-3{
  /* background-image: linear-gradient( 117deg,  rgba(123,216,96,1) 39.2%, rgba(255,255,255,1) 156.2% ); */
  /* background-image: linear-gradient( 180.5deg,  rgba(46,255,171,1) 12.3%, rgba(252,251,222,0.46) 92% ); */
  background-image: linear-gradient( 109.6deg,  rgba(223,234,247,1) 11.2%, rgba(244,248,252,1) 91.1% );
}
.flex-shrink-0 {
  -ms-flex-negative: 0 !important;
  flex-shrink: 0 !important;
}
.flex-grow-1 {
  -webkit-box-flex: 1 !important;
  -ms-flex-positive: 1 !important;
  flex-grow: 1 !important;
}
.d-flex {
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: flex !important;
}
.badge-soft-success {
  color: #e8bc52;
background-color: rgba(232,188,82,.1);
display: inline-block;
padding: 2px 2px;
font-size: 14px;
font-weight: 500;
line-height: 1;
text-align: center;
white-space: nowrap;
vertical-align: baseline;
border-radius: 10px;
}
.card-2{
  margin-bottom: 1.1rem;
  -webkit-box-shadow: 0 1px 2px rgba(56,65,74,.15);
  box-shadow: 0 1px 2px rgba(56,65,74,.15);
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-image: linear-gradient( 181.2deg,  rgba(181,239,249,1) 10.5%, rgba(254,254,254,1) 86.8% );
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.13);
  border-radius: 0.25rem;
}
.card-header-1:first-child {
  border-radius: 0.25rem 0.25rem 0 0;
}
.card-header-1 {
  border-bottom: 1px solid #e9ebec;
}
.card-header-1 {
  padding: 1rem 1rem;
  margin-bottom: 0;
  background-color: #fff;
}
.card-title {
  font-size: 17px;
  margin: 0 0 7px 0;
    margin-bottom: 7px;
}
h5 {
  font-weight: 600;
  line-height: 1.2;
}
.text-muted {
  --vz-text-opacity: 1;
  color: #878a99 !important;
}
@-moz-keyframes facebookSpinner {
  0% {
    -moz-transform: scale(1, 1);
    transform: scale(1, 1);
    opacity: 1;
  }
  100% {
    -moz-transform: scale(0.7, 0.7);
    transform: scale(0.7, 0.7);
    opacity: 0.1;
  }
}
@-webkit-keyframes facebookSpinner {
  0% {
    -webkit-transform: scale(1, 1);
    transform: scale(1, 1);
    opacity: 1;
  }
  100% {
    -webkit-transform: scale(0.7, 0.7);
    transform: scale(0.7, 0.7);
    opacity: 0.1;
  }
}
@keyframes facebookSpinner {
  0% {
    -moz-transform: scale(1, 1);
    -ms-transform: scale(1, 1);
    -webkit-transform: scale(1, 1);
    transform: scale(1, 1);
    opacity: 1;
  }
  100% {
    -moz-transform: scale(0.7, 0.7);
    -ms-transform: scale(0.7, 0.7);
    -webkit-transform: scale(0.7, 0.7);
    transform: scale(0.7, 0.7);
    opacity: 0.1;
  }
}
.facebook-spinner {
  width: 25px;
  height: 28px;
  display: inline-block;
  vertical-align: middle;
}
.facebook-spinner .spinner-block {
  float: left;
  width: 7px;
  height: 28px;
  background-color: #8b9dc3;
  border: 1px solid #3b5998;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -moz-animation-name: facebookSpinner;
  -webkit-animation-name: facebookSpinner;
  animation-name: facebookSpinner;
  -moz-animation-duration: 1s;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -moz-animation-iteration-count: infinite;
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
}
.facebook-spinner .spinner-block:not(:last-child) {
  margin-right: 2px;
}
.facebook-spinner .block-1 {
  -moz-animation-delay: 100ms;
  -webkit-animation-delay: 100ms;
  animation-delay: 100ms;
}
.facebook-spinner .block-2 {
  -moz-animation-delay: 200ms;
  -webkit-animation-delay: 200ms;
  animation-delay: 200ms;
}
.facebook-spinner .block-3 {
  -moz-animation-delay: 300ms;
  -webkit-animation-delay: 300ms;
  animation-delay: 300ms;
}


.me-1 {
  margin-right: .25rem !important;
}
.align-middle {
  vertical-align: middle !important;
}
.card-body-2 {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  padding: 1rem 1rem;
}
  .card-body-1 {
    flex: 1 1 auto;
    min-height: 1px;
}
.bg-light-primary {
  background-color: #0bc1f712;
  border-color: #3182ce;
}
.bg-blue-box{
  background: linear-gradient(112.14deg, #00D2FF 0%, #3A7BD5 100%);
  color: white;
}
.card-1 {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
}
.header-table.th-header{
  background-color: #d4ebff;
}
.header-1 .content{
  height: inherit !important;
  }
.header-table{
  padding-left: 5px;
}
.x8yj6t5 {
  width: 10% !important;
}
.x8yj6t55{
  width: 15%;
}
.quant{
  margin: 0 !important;
}
.vm2_wrapper{
  z-index: 11;
}
.icon::after {
  content: "";
  display: block;
  position: absolute;
  border-top: 23px solid transparent;
  border-bottom: 17px solid transparent;
  border-left: 12px solid #3182ce;
  left: 100%;
  top: 0;
}
.v-select{
  width: 100%;
}
.vs__dropdown-toggle {
    border: none;
}
dialog[open] {
  animation: appear 0.15s cubic-bezier(0, 1.8, 1, 1.8);
}

dialog::backdrop {
  background: linear-gradient(45deg, rgba(0, 0, 0, 0.5), rgba(54, 54, 54, 0.5));
  backdrop-filter: blur(3px);
}

@keyframes appear {
  from {
    opacity: 0;
    transform: translateX(-3rem);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.label {
  transition: all 0.2s ease-out;
  top: 0.4rem;
  left: 0;
}
.flip-clock {
  text-align: center;
  perspective: 600px;
  margin: 0 auto;
}

.flip-clock__piece {
  display: inline-block;
  margin: 0 0.2vw;
  
  @media (min-width: 1000px) {
    margin: 0 5px;
  }
}

.flip-clock__slot {
  font-size: 1rem;
  line-height: 1.5;
  display: block;
}

.flip-card {
  display: block;
  position: relative;
  padding-bottom: 0.1em;
  font-size: 2.25rem;
  line-height: 0.95;
}

@media (min-width: 1000px) {
  .flip-clock__slot { font-size: 1.2rem; }
  .flip-card { font-size: 3rem; }
}


/*////////////////////////////////////////*/


.flip-card__top,
.flip-card__bottom,
.flip-card__back-bottom,
.flip-card__back::before,
.flip-card__back::after {
  display: block;
  height: 1.44em;
  color: #ccc;
  background: #222;
  padding: 0.23em 0.25em 0.4em;
  border-radius: 0.15em 0.15em 0.15em 0.15em;
  backface-visiblity: hidden;
  transform-style: preserve-3d;
  width: 1.8em;
}

.flip-card__bottom,
.flip-card__back-bottom {
  color: #FFF;
  position: absolute;
  top: 50%;
  left: 0;
  border-top: solid 1px #000;
  background: #393939;
  border-radius: 0 0 0.15em 0.15em;
  pointer-events: none;
  overflow: hidden;
  z-index: 2;
}

.flip-card__back-bottom {
  z-index: 1;
}

.flip-card__bottom::after,
.flip-card__back-bottom::after {
  display: block;
  margin-top: -0.72em;
}

.flip-card__back::before,
.flip-card__bottom::after,
.flip-card__back-bottom::after {
  content: attr(data-value);
}

.flip-card__back {
  position: absolute;
  top: 0;
  height: 100%;
  left: 0%;
  pointer-events: none;
}

.flip-card__back::before {
  position: relative;
  overflow: hidden;
  z-index: -1;
}

.flip .flip-card__back::before {
  z-index: 1;
  animation: flipTop 0.3s cubic-bezier(.37,.01,.94,.35);
  animation-fill-mode: both;
  transform-origin: center bottom;
}

.flip .flip-card__bottom {
  transform-origin: center top;
  animation-fill-mode: both;
  animation: flipBottom 0.6s cubic-bezier(.15,.45,.28,1);
}
.icon-call{
  font-size: 40px;
}
@keyframes flipTop {
  0% {
    transform: rotateX(0deg);
    z-index: 2;
  }
  0%, 99% {
    opacity: 1;
  }
  100% {
    transform: rotateX(-90deg);
    opacity: 0;
  }
}

@keyframes flipBottom {
  0%, 50% {
    z-index: -1;
    transform: rotateX(90deg);
    opacity: 0;
  }
  51% {
    opacity: 1;
  }
  100% {
    opacity: 1;
    transform: rotateX(0deg);
    z-index: 5;
  }
}
</style>


